// @ts-nocheck
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Scalars = {
    String: string,
    ID: string,
    Boolean: boolean,
    Int: number,
    Float: number,
    Upload: any,
}

export type AddressInterface = (BillingCartAddress | ShippingCartAddress | OrderAddress | CustomerAddress) & { __isUnion?: true }

export interface StoreInformation {
    code: Scalars['ID']
    /** The name of the current store */
    name: Scalars['String']
    /** The name of the company */
    companyName: (Scalars['String'] | null)
    /** The locale of the current store */
    locale: Scalars['String']
    /** The language of the current store */
    language: Scalars['String']
    /** Two letter abbreviation of language of the current store */
    languageTwoLetterAbbreviation: Scalars['String']
    /** The country of the current store */
    country: Country
    /** The available countries of the current store */
    countries: Country[]
    /** The root category of the current store */
    rootCategory: Category
    /** The base url of the current store */
    baseUrl: Scalars['String']
    /** The timezone of the current store */
    timezone: Scalars['String']
    /** The currency code of the current store */
    currency: Scalars['String']
    customerService: CustomerService
    kiyoh: KiyohInformation
    companyVideo: (Scalars['String'] | null)
    /** @deprecated Facebook is being deprecated */
    facebook: (FacebookInformation | null)
    paymentMethods: AvailablePaymentMethod[]
    addressValidationAvailable: (Scalars['Boolean'] | null)
    isCheckModeEnabled: Scalars['Boolean']
    __typename: 'StoreInformation'
}

export interface CustomerService {
    /** The status of the customer service */
    isOpen: Scalars['Boolean']
    /** A random image of a customer service employee */
    image: (Scalars['String'] | null)
    /** An information message to display */
    closeMessage: Scalars['String']
    /** The time when the customer service opens */
    openTime: Scalars['String']
    /** The time when the customer service closes */
    closeTime: Scalars['String']
    __typename: 'CustomerService'
}

export interface Country {
    availableRegions: Region[]
    regionRequired: Scalars['Boolean']
    fullNameLocale: Scalars['String']
    /** The unique ID for a Country object. */
    id: Scalars['ID']
    threeLetterAbbreviation: Scalars['String']
    twoLetterAbbreviation: Scalars['String']
    __typename: 'Country'
}

export interface Region {
    code: Scalars['String']
    /** The unique ID for a Region object. */
    id: Scalars['ID']
    name: Scalars['String']
    __typename: 'Region'
}

export interface FacebookInformation {
    facebookLikes: (Scalars['Int'] | null)
    pageId: (Scalars['String'] | null)
    chatEnabled: (Scalars['Boolean'] | null)
    __typename: 'FacebookInformation'
}

export interface Website {
    /** The current store view */
    current: StoreInformation
    /** The the available store views */
    available: StoreInformation[]
    __typename: 'Website'
}


/** The list of available currency codes */
export type CurrencyEnum = 'AFN' | 'ALL' | 'DZD' | 'USD' | 'AOA' | 'ARS' | 'AMD' | 'AWG' | 'AUD' | 'AZN' | 'AZM' | 'BSD' | 'BHD' | 'BBD' | 'BZD' | 'BDT' | 'BMD' | 'BTN' | 'BUK' | 'BOB' | 'BAM' | 'BWP' | 'BRL' | 'GBP' | 'BND' | 'BGN' | 'BIF' | 'XOF' | 'XPF' | 'KHR' | 'CAD' | 'KYD' | 'CLP' | 'CNY' | 'COP' | 'KMF' | 'CDF' | 'CRC' | 'CUP' | 'DKK' | 'DJF' | 'DOP' | 'EGP' | 'GQE' | 'ERN' | 'EEK' | 'ETB' | 'EUR' | 'FKP' | 'FJD' | 'PHP' | 'GMD' | 'GEK' | 'GEL' | 'GHS' | 'GIP' | 'GTQ' | 'GNF' | 'GYD' | 'HTG' | 'HNL' | 'HUF' | 'HKD' | 'ISK' | 'INR' | 'IDR' | 'IQD' | 'IRR' | 'ILS' | 'JMD' | 'JPY' | 'YER' | 'JOD' | 'CVE' | 'KZT' | 'KES' | 'KGS' | 'KWD' | 'HRK' | 'LAK' | 'LSL' | 'LVL' | 'LBP' | 'LRD' | 'LYD' | 'LTL' | 'MOP' | 'MKD' | 'MGA' | 'MWK' | 'MVR' | 'MYR' | 'MAD' | 'MRO' | 'MUR' | 'MXN' | 'MDL' | 'MNT' | 'MZN' | 'MMK' | 'NAD' | 'ANG' | 'NPR' | 'NIC' | 'NZD' | 'TWD' | 'NGN' | 'KPW' | 'NOK' | 'UGX' | 'UAH' | 'UZS' | 'OMR' | 'XCD' | 'ROL' | 'PKR' | 'PAB' | 'PGK' | 'PYG' | 'PEN' | 'PLN' | 'QAR' | 'RHD' | 'RON' | 'RUB' | 'RWF' | 'SBD' | 'SVC' | 'WST' | 'STD' | 'SAR' | 'RSD' | 'SCR' | 'SLL' | 'SGD' | 'SHP' | 'SKK' | 'SDG' | 'SOS' | 'LKR' | 'SRD' | 'SZL' | 'SYP' | 'TJS' | 'TZS' | 'THB' | 'TOP' | 'TTD' | 'CZK' | 'TND' | 'TMM' | 'TRY' | 'TRL' | 'UYU' | 'VUV' | 'VEF' | 'VEB' | 'AED' | 'VND' | 'CHE' | 'CHW' | 'BYR' | 'ZMK' | 'ZWD' | 'ZAR' | 'KRW' | 'SEK' | 'CHF'

export type PaymentChargeEnum = 'PERCENTAGE' | 'FIXED_VALUE'

export type CartItemTypeEnum = 'DEFAULT' | 'CHILD'

export type PaymentMethodInterface = (AvailablePaymentMethod | SelectedPaymentMethod) & { __isUnion?: true }

export type ShippingMethodInterface = (SelectedShippingMethod | AvailableShippingMethod) & { __isUnion?: true }

export interface AvailablePaymentMethod {
    code: Scalars['ID']
    title: (Scalars['String'] | null)
    logo: (Scalars['String'] | null)
    paymentCharge: (Scalars['Float'] | null)
    paymentChargeTotal: Money
    paymentChargeType: (PaymentChargeEnum | null)
    description: (Scalars['String'] | null)
    options: ((PaymentOption | null)[] | null)
    __typename: 'AvailablePaymentMethod'
}

export interface BillingCartAddress {
    /** The city or town */
    city: (Scalars['String'] | null)
    /** The company */
    company: (Scalars['String'] | null)
    country: (CartAddressCountry | null)
    region: (CartAddressRegion | null)
    /** The first name of the person associated with the shipping/billing address */
    firstname: (Scalars['String'] | null)
    /** The last name of the person associated with the shipping/billing address */
    lastname: (Scalars['String'] | null)
    /** The customer's ZIP or postal code */
    postcode: (Scalars['String'] | null)
    street: (Scalars['String'] | null)
    street2: (Scalars['String'] | null)
    /** The telephone number */
    telephone: (Scalars['String'] | null)
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId: (Scalars['String'] | null)
    id: Scalars['ID']
    customerAddressId: (Scalars['Int'] | null)
    __typename: 'BillingCartAddress'
}

export interface CartAddressCountry {
    code: (Scalars['String'] | null)
    label: (Scalars['String'] | null)
    __typename: 'CartAddressCountry'
}

export interface CartAddressRegion {
    code: (Scalars['String'] | null)
    label: (Scalars['String'] | null)
    __typename: 'CartAddressRegion'
}

export interface CartItem {
    id: Scalars['ID']
    name: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    image: (Scalars['String'] | null)
    sortOrder: (Scalars['String'] | null)
    parent: (CartItem | null)
    children: CartItem[]
    product: (Product | null)
    quantity: Scalars['Int']
    group: Scalars['String']
    specs: (ItemSpecifications | null)
    orderData: (Scalars['String'] | null)
    isOptimized: Scalars['Boolean']
    reservedUntil: (Scalars['String'] | null)
    totals: CartItemTotals
    __typename: 'CartItem'
}

export interface ProductPagination {
    /** List of items on the current page */
    items: Product[]
    /** Number of total items selected by the query */
    total: Scalars['Int']
    /** Number of items returned per page */
    perPage: Scalars['Int']
    /** Current page of the cursor */
    currentPage: Scalars['Int']
    /** The last page (number of pages) */
    lastPage: Scalars['Int']
    /** Determines if cursor has more pages after the current page */
    hasMorePages: Scalars['Boolean']
    __typename: 'ProductPagination'
}

export interface CartGroup {
    /** cart group code */
    id: Scalars['String']
    /** Name of the cart group */
    name: Scalars['String']
    /** Link to cart group type */
    url: (Scalars['String'] | null)
    __typename: 'CartGroup'
}

export interface CartItemTotals {
    price: Money
    rowTotal: Money
    __typename: 'CartItemTotals'
}

export interface Cart {
    id: Scalars['ID']
    customerEmail: (Scalars['String'] | null)
    customerPhone: (Scalars['String'] | null)
    customerCompany: (Scalars['String'] | null)
    customerTaxvat: (Scalars['String'] | null)
    customerInvoiceEmail: (Scalars['String'] | null)
    customerComment: (Scalars['String'] | null)
    shippingComment: (Scalars['String'] | null)
    updatedAt: Scalars['String']
    totalQuantity: Scalars['Int']
    billingAddress: BillingCartAddress
    shippingAddress: ShippingCartAddress
    items: CartItem[]
    appliedCoupon: (Scalars['String'] | null)
    isVirtual: (Scalars['Boolean'] | null)
    totals: CartTotals
    selectedPaymentMethod: (SelectedPaymentMethod | null)
    availablePaymentMethods: AvailablePaymentMethod[]
    cartGroup: CartGroup[]
    useRestPieces: Scalars['Boolean']
    orderComment: (Scalars['String'] | null)
    poNumber: (Scalars['String'] | null)
    orderNewsletter: (Scalars['Boolean'] | null)
    crosssellProducts: ProductPagination
    __typename: 'Cart'
}

export interface CartTotals {
    grandTotal: PriceLabel
    subTotal: PriceLabel
    shipping: PriceLabel
    tax: PriceLabel
    taxPercentage: Scalars['Float']
    discount: PriceLabel
    paymentCharge: PriceLabel
    __typename: 'CartTotals'
}

export interface OrderItemTotals {
    price: Money
    rowTotal: Money
    __typename: 'OrderItemTotals'
}

export interface PriceLabel {
    label: Scalars['String']
    price: Money
    __typename: 'PriceLabel'
}


/** A Money object defines a monetary value, including a numeric value and a currency code. */
export interface Money {
    /** A three-letter currency code, such as USD or EUR */
    currency: CurrencyEnum
    display: PriceDisplay
    includingTax: Scalars['Float']
    excludingTax: Scalars['Float']
    __typename: 'Money'
}

export interface PaymentOption {
    optionId: Scalars['ID']
    name: (Scalars['String'] | null)
    logo: (Scalars['String'] | null)
    __typename: 'PaymentOption'
}

export interface PlaceOrderOutput {
    orderNumber: Scalars['String']
    url: Scalars['String']
    monduToken: (Scalars['String'] | null)
    __typename: 'PlaceOrderOutput'
}

export interface SelectedPaymentMethod {
    code: Scalars['ID']
    title: (Scalars['String'] | null)
    logo: (Scalars['String'] | null)
    paymentCharge: (Scalars['Float'] | null)
    paymentChargeTotal: Money
    paymentChargeType: (PaymentChargeEnum | null)
    description: (Scalars['String'] | null)
    option: (PaymentOption | null)
    __typename: 'SelectedPaymentMethod'
}

export interface ShippingCartAddress {
    /** The city or town */
    city: (Scalars['String'] | null)
    /** The company */
    company: (Scalars['String'] | null)
    country: (CartAddressCountry | null)
    region: (CartAddressRegion | null)
    /** The first name of the person associated with the shipping/billing address */
    firstname: (Scalars['String'] | null)
    /** The last name of the person associated with the shipping/billing address */
    lastname: (Scalars['String'] | null)
    /** The customer's ZIP or postal code */
    postcode: (Scalars['String'] | null)
    street: (Scalars['String'] | null)
    street2: (Scalars['String'] | null)
    /** The telephone number */
    telephone: (Scalars['String'] | null)
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId: (Scalars['String'] | null)
    id: Scalars['ID']
    customerAddressId: (Scalars['Int'] | null)
    sameAsBilling: Scalars['Boolean']
    availableShippingMethods: ShippingCarrier[]
    selectedShippingMethod: (SelectedShippingCarrier | null)
    __typename: 'ShippingCartAddress'
}

export interface ShippingCarrier {
    /** A string that identifies a commercial carrier or an offline shipping method. */
    carrierCode: Scalars['String']
    /** The label for the carrier code. */
    carrierTitle: (Scalars['String'] | null)
    isTakeaway: Scalars['Boolean']
    /** The description of the method */
    description: (Scalars['String'] | null)
    banner: (Scalars['String'] | null)
    methods: AvailableShippingMethod[]
    __typename: 'ShippingCarrier'
}

export interface SelectedShippingCarrier {
    /** A string that identifies a commercial carrier or an offline shipping method. */
    carrierCode: Scalars['String']
    /** The label for the carrier code. */
    carrierTitle: (Scalars['String'] | null)
    isTakeaway: Scalars['Boolean']
    /** The description of the method */
    description: (Scalars['String'] | null)
    banner: (Scalars['String'] | null)
    method: SelectedShippingMethod
    __typename: 'SelectedShippingCarrier'
}

export interface SelectedShippingMethod {
    /** A shipping method code associated with a carrier. */
    methodCode: Scalars['String']
    /** The label for the method code. */
    methodTitle: (Scalars['String'] | null)
    /** Deprecated */
    offsetLabel: (Scalars['String'] | null)
    /** The cost of shipping using this shipping method, including tax */
    price: Money
    description: (Scalars['String'] | null)
    /** Get the opening hours of take away location */
    openingHours: (Scalars['String'] | null)
    /** Check if dates are available */
    hasSelectableDate: Scalars['Boolean']
    /** Check if the user can select a date */
    datesEnabled: Scalars['Boolean']
    /** First available delivery date */
    firstAvailableDeliveryDate: Scalars['String']
    /** Last available delivery date */
    lastAvailableDeliveryDate: Scalars['String']
    /** Check if delivery instructions are available */
    hasDeliveryInstructions: Scalars['Boolean']
    /** Delivery instructions comment */
    deliveryInstructionsComment: (Scalars['String'] | null)
    /** Selected delivery date */
    deliveryDate: (Scalars['String'] | null)
    __typename: 'SelectedShippingMethod'
}

export interface AvailableShippingMethod {
    /** A shipping method code associated with a carrier. */
    methodCode: Scalars['String']
    /** The label for the method code. */
    methodTitle: (Scalars['String'] | null)
    /** Deprecated */
    offsetLabel: (Scalars['String'] | null)
    /** The cost of shipping using this shipping method, including tax */
    price: Money
    description: (Scalars['String'] | null)
    /** Get the opening hours of take away location */
    openingHours: (Scalars['String'] | null)
    /** Check if dates are available */
    hasSelectableDate: Scalars['Boolean']
    /** Check if the user can select a date */
    datesEnabled: Scalars['Boolean']
    /** First available delivery date */
    firstAvailableDeliveryDate: Scalars['String']
    /** Last available delivery date */
    lastAvailableDeliveryDate: Scalars['String']
    /** Check if delivery instructions are available */
    hasDeliveryInstructions: Scalars['Boolean']
    /** Delivery instructions comment */
    deliveryInstructionsComment: (Scalars['String'] | null)
    /** Available delivery dates for the shipping method */
    deliveryDates: (Scalars['String'][] | null)
    __typename: 'AvailableShippingMethod'
}

export interface UpdateCartResult {
    item: CartItem
    cart: Cart
    __typename: 'UpdateCartResult'
}

export interface CreditMemo {
    id: Scalars['ID']
    __typename: 'CreditMemo'
}

export interface Shipment {
    id: Scalars['ID']
    tracking: (ShipmentTracking | null)
    __typename: 'Shipment'
}

export interface ShipmentTracking {
    id: Scalars['ID']
    carrier: Scalars['String']
    title: Scalars['String']
    number: Scalars['String']
    __typename: 'ShipmentTracking'
}

export interface Invoice {
    id: Scalars['ID']
    total: InvoiceTotal
    downloadLink: Scalars['String']
    __typename: 'Invoice'
}

export interface InvoiceTotal {
    tax: Money
    shipping: Money
    subTotal: Money
    grandTotal: Money
    __typename: 'InvoiceTotal'
}


/** OrderAddress contains detailed information about an order's billing and shipping addresses */
export interface OrderAddress {
    /** The city or town */
    city: (Scalars['String'] | null)
    /** The company */
    company: (Scalars['String'] | null)
    country: (CartAddressCountry | null)
    region: (CartAddressRegion | null)
    /** The first name of the person associated with the shipping/billing address */
    firstname: (Scalars['String'] | null)
    /** The last name of the person associated with the shipping/billing address */
    lastname: (Scalars['String'] | null)
    /** The customer's ZIP or postal code */
    postcode: (Scalars['String'] | null)
    street: (Scalars['String'] | null)
    /** The second line of the street address */
    street2: (Scalars['String'] | null)
    /** The telephone number */
    telephone: (Scalars['String'] | null)
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId: (Scalars['String'] | null)
    id: Scalars['ID']
    __typename: 'OrderAddress'
}


/** Contains totals of the order */
export interface OrderTotals {
    /** Order subtotal including tax */
    subTotal: Money
    shipping: Money
    discount: Money
    tax: Money
    taxPercentage: Scalars['Float']
    grandTotal: Money
    totalPaid: Money
    totalRefunded: Money
    totalDue: Money
    __typename: 'OrderTotals'
}

export interface OrderItem {
    id: Scalars['ID']
    sku: Scalars['String']
    name: (Scalars['String'] | null)
    image: (Scalars['String'] | null)
    sortOrder: (Scalars['String'] | null)
    children: OrderItem[]
    product: (Product | null)
    quantity: Scalars['Int']
    group: Scalars['String']
    specs: (ItemSpecifications | null)
    orderData: (Scalars['String'] | null)
    totals: OrderItemTotals
    description: (Scalars['String'] | null)
    __typename: 'OrderItem'
}


/** Contains details about the order */
export interface OrderSuccess {
    store: StoreInformation
    incrementId: Scalars['ID']
    email: Scalars['String']
    deliveryDate: Scalars['String']
    shippingDescription: (Scalars['String'] | null)
    isTakeaway: Scalars['Boolean']
    /** The shipping address for the order */
    shippingAddress: (OrderAddress | null)
    cartGroup: CartGroup[]
    items: OrderItem[]
    totals: OrderTotals
    refundAmount: (Money | null)
    projectUrl: (Scalars['String'] | null)
    __typename: 'OrderSuccess'
}

export interface AppliedFinish {
    finish: Finish
    option: FinishOption
    side: FinishSide
    __typename: 'AppliedFinish'
}

export interface Dimensions {
    width: Scalars['String']
    height: Scalars['String']
    depth: Scalars['String']
    __typename: 'Dimensions'
}

export interface CabinetSpecs {
    heading: Scalars['String']
    data: CabinetSpecsData[]
    __typename: 'CabinetSpecs'
}

export interface CabinetSpecsData {
    label: (Scalars['String'] | null)
    value: (Scalars['String'] | null)
    __typename: 'CabinetSpecsData'
}

export interface WoodSpecification {
    dimensionsHtml: Scalars['String']
    shape: Shape
    finishes: AppliedFinish[]
    label: (Scalars['String'] | null)
    /** Dimensions of panel as used in Optimization without margins */
    optimizationDimensions: OptimizationDimensions
    __typename: 'WoodSpecification'
}

export interface WoodCompleteSpecification {
    panelQuantity: Scalars['Int']
    optimizations: OptimizationResult[]
    shipBoards: Scalars['Boolean']
    __typename: 'WoodCompleteSpecification'
}

export interface WoodCompleteRestSpecification {
    dimensionsHtml: Scalars['String']
    shape: Shape
    __typename: 'WoodCompleteRestSpecification'
}

export interface PlasticSpecification {
    dimensionsHtml: Scalars['String']
    shape: Shape
    finishes: AppliedFinish[]
    label: (Scalars['String'] | null)
    __typename: 'PlasticSpecification'
}

export interface SheetFurnitureSpecification {
    dimensions: (Dimensions | null)
    specs: (CabinetSpecs | null)
    dimensionsHtml: Scalars['String']
    __typename: 'SheetFurnitureSpecification'
}

export interface TableSpecification {
    shape: Shape
    finishes: AppliedFinish[]
    dimensionsHtml: Scalars['String']
    topLayer: Scalars['String']
    thickness: Scalars['String']
    __typename: 'TableSpecification'
}

export interface FeeSpecification {
    attachments: Scalars['String'][]
    __typename: 'FeeSpecification'
}

export interface OptimizationResult {
    length: Scalars['Float']
    width: Scalars['Float']
    panelLength: Scalars['Float']
    panelWidth: Scalars['Float']
    items: OptimizationItem[]
    boards: OptimizationItem[]
    __typename: 'OptimizationResult'
}

export interface OptimizationItem {
    id: Scalars['String']
    length: Scalars['Float']
    width: Scalars['Float']
    x: Scalars['Float']
    y: Scalars['Float']
    __typename: 'OptimizationItem'
}


/** Dimensions of panel as used in Optimization without margins */
export interface OptimizationDimensions {
    length: Scalars['Float']
    width: Scalars['Float']
    __typename: 'OptimizationDimensions'
}

export type ItemSpecifications = (WoodSpecification | WoodCompleteSpecification | WoodCompleteRestSpecification | PlasticSpecification | TableSpecification | FeeSpecification | SheetFurnitureSpecification) & { __isUnion?: true }

export interface Products {
    /** An array of products that match the specified search criteria. */
    items: Product[]
    /** An object that includes the pageInfo and currentPage values specified in the query. */
    pageInfo: PageInfo
    /** An object that includes the default sort field and all available sort fields. */
    sortFields: SortFields
    listMode: Scalars['String']
    /** An object that includes all the options for the grid per page filter */
    gridPerPage: ProductsPerPage
    /** An object that includes all the options for the list per page filter */
    listPerPage: ProductsPerPage
    /** Layered navigation aggregations */
    aggregations: Aggregation[]
    __typename: 'Products'
}

export interface Product {
    name: (Scalars['String'] | null)
    shortDescription: (Scalars['String'] | null)
    /** SKU */
    sku: Scalars['String']
    price: Money
    specialPrice: (Scalars['Float'] | null)
    specialFromDate: (Scalars['String'] | null)
    specialToDate: (Scalars['String'] | null)
    image: (Scalars['String'] | null)
    /** Small Image */
    smallImage: (Scalars['String'] | null)
    /** Thumbnail */
    thumbnail: (Scalars['String'] | null)
    newsFromDate: (Scalars['String'] | null)
    newsToDate: (Scalars['String'] | null)
    /** Status */
    status: Scalars['String']
    urlKey: (Scalars['String'] | null)
    requiredOptions: (Scalars['String'] | null)
    imageLabel: (Scalars['String'] | null)
    smallImageLabel: (Scalars['String'] | null)
    thumbnailLabel: (Scalars['String'] | null)
    msrpEnabled: (Scalars['String'] | null)
    msrpDisplayActualPriceType: (Scalars['String'] | null)
    msrp: (Scalars['Float'] | null)
    /** Tax Class */
    taxClassId: Scalars['String']
    priceType: Scalars['Int']
    weightType: Scalars['Int']
    priceView: Scalars['String']
    shipmentType: Scalars['Int']
    linksPurchasedSeparately: Scalars['Int']
    linksExist: (Scalars['Int'] | null)
    /** Variant */
    typeFinish: (Scalars['String'] | null)
    /** Max. Width (mm) */
    maxWidth: Scalars['String']
    /** Max. Length (mm) */
    maxLength: Scalars['String']
    /** Thickness */
    thicknessOld: (Scalars['String'][] | null)
    positiveNegative: (Scalars['String'] | null)
    /** Used wood */
    woodUsed: (Scalars['String'] | null)
    /** Dimension of unity */
    productUnit: Scalars['String']
    /** Standard length in mm */
    standardLength: Scalars['String']
    /** Standard width in mm */
    standardWidth: Scalars['String']
    /** Width */
    width: (Scalars['String'] | null)
    /** Packaging unit */
    packagingUnit: (Scalars['String'] | null)
    /** Brand */
    brand: (Scalars['String'] | null)
    /** Depth */
    depth: (Scalars['String'] | null)
    /** Height */
    height: (Scalars['String'] | null)
    supplier: (Scalars['String'] | null)
    /** Headmaat */
    kopmaat: (Scalars['String'] | null)
    /** Color code */
    colorCode: (Scalars['String'] | null)
    /** Explanation of wood type at cupboards */
    woodExplanationFurniture: (Scalars['String'] | null)
    stockMessage: (Scalars['String'] | null)
    /** Grain */
    grainType: (Scalars['String'] | null)
    /** Top layer type */
    toplayerType: (Scalars['String'] | null)
    /** Hover image */
    hoverImage: (Scalars['String'] | null)
    /** Label text for cat. page */
    labelCategoryPage: (Scalars['String'] | null)
    appearance: (Scalars['String'] | null)
    /** Pas gordelomvang beperkingen toe van DPD. */
    applyBeltSize: Scalars['Boolean']
    pimImageBase: (Scalars['String'] | null)
    pimImageDetail: (Scalars['String'] | null)
    pimImageGallery: (Scalars['String'] | null)
    jsonConfiguration: (Scalars['String'] | null)
    productionUnit: (Scalars['String'] | null)
    cabinetOuterWidth: (Scalars['String'] | null)
    cabinetOuterDepth: (Scalars['String'] | null)
    cabinetOuterHeight: (Scalars['String'] | null)
    stockPosition: (Scalars['String'] | null)
    ncsColorCode: (Scalars['String'] | null)
    pmsColorCode: (Scalars['String'] | null)
    deliveryOffset: (Scalars['String'] | null)
    purchaseType: (Scalars['String'][] | null)
    priceM2CompletePanel: (Scalars['Float'] | null)
    deliveryTime: (Scalars['String'] | null)
    priceM2UncutPanel: (Scalars['Float'] | null)
    thickness: (Scalars['String'] | null)
    diyProjectCode: (Scalars['String'] | null)
    id: Scalars['ID']
    finalPrice: Money
    lowestPrice: Money
    category: (Category | null)
    /** Category tree only to be used in product view */
    categories: Category[]
    faqCategoryIds: Scalars['ID'][]
    description: (Scalars['String'] | null)
    woodApplications: (Scalars['String'] | null)
    metaTitle: (Scalars['String'] | null)
    metaKeywords: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    hrefLang: HrefLang[]
    attributeSet: Scalars['String']
    maxDimensions: (Scalars['String'] | null)
    fastestDeliveryDate: (Scalars['String'] | null)
    customStock: (Scalars['Int'] | null)
    isSalable: (Scalars['Boolean'] | null)
    configurable: (Scalars['Boolean'] | null)
    url: Scalars['String']
    attributes: ProductAttribute[]
    requestPath: Scalars['String']
    productType: (ProductType | null)
    typeId: Scalars['String']
    imageBase: (Scalars['String'] | null)
    imageDetail: (Scalars['String'] | null)
    imageGallery: ImageGalleryType[]
    videoGallery: Scalars['String'][]
    groupedProductId: (Scalars['String'] | null)
    sampleProduct: (Product | null)
    alternativeProduct: (Product | null)
    crosssellProducts: ProductPagination
    associatedProducts: ProductPagination
    specificationSheets: SpecificationSheet[]
    isOnWishlist: Scalars['Boolean']
    __typename: 'Product'
}

export interface ProductAttribute {
    code: Scalars['String']
    label: Scalars['String']
    value: (Scalars['String'] | null)
    optionId: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    hasDescription: Scalars['Boolean']
    __typename: 'ProductAttribute'
}

export interface Category {
    /** URL KEY */
    urlKey: (Scalars['String'] | null)
    /** Description */
    description: (Scalars['String'] | null)
    image: (Scalars['String'] | null)
    /** Meta Title */
    metaTitle: (Scalars['String'] | null)
    metaKeywords: (Scalars['String'] | null)
    /** Meta Description */
    metaDescription: (Scalars['String'] | null)
    path: (Scalars['String'] | null)
    urlPath: (Scalars['String'] | null)
    seoContent: (Scalars['String'] | null)
    id: Scalars['ID']
    name: (Scalars['String'] | null)
    requestPath: (Scalars['String'] | null)
    url: Scalars['String']
    hrefLang: HrefLang[]
    isUsedForSeo: (Scalars['Int'] | null)
    displayType: (Scalars['Int'] | null)
    hasChildren: Scalars['Boolean']
    children: Category[]
    parent: Category
    parents: Category[]
    level: (Scalars['Int'] | null)
    __typename: 'Category'
}

export type UrlType = 'CATEGORY' | 'PRODUCT' | 'DIY_OVERVIEW' | 'DIY_DETAIL' | 'DIY_CATEGORY' | 'DIY_CATEGORY_LANDING' | 'CUSTOMER_SERVICE_OVERVIEW' | 'CUSTOMER_SERVICE_VIEW' | 'CUSTOMER_SERVICE_DETAIL' | 'CUSTOMER_REVIEWS' | 'VIDEOS_OVERVIEW' | 'VIDEOS_DETAIL' | 'BUSINESS_OVERVIEW' | 'STYLIST_DETAIL' | 'STYLIST_OVERVIEW' | 'LANDING' | 'LANDING_OVERVIEW' | 'TIPS' | 'TIPS_OVERVIEW' | 'POST' | 'BRAND' | 'BRAND_OVERVIEW' | 'KNOWLEDGE' | 'KNOWLEDGE_OVERVIEW' | 'DIY_HOME' | 'POST_OVERVIEW' | 'BLOGGERS' | 'DIY_SEND' | 'FAQ_ITEM'

export interface UrlResolverResult {
    id: Scalars['ID']
    type: (UrlType | null)
    redirect: Scalars['Boolean']
    permanent: Scalars['Boolean']
    path: Scalars['String']
    __typename: 'UrlResolverResult'
}

export type SortInput = 'ASC' | 'DESC'

export interface AggregationOption {
    /** The number of items that match the aggregation option. */
    count: (Scalars['Int'] | null)
    /** Aggregation option display label. */
    label: (Scalars['String'] | null)
    /** The internal ID that represents the value of the option. */
    value: Scalars['String']
    __typename: 'AggregationOption'
}


/** A bucket that contains information for each filterable option (such as price, category ID, and custom attributes). */
export interface Aggregation {
    /** Attribute code of the aggregation group. */
    attribute_code: Scalars['String']
    /** The aggregation display name. */
    label: Scalars['String']
    /** Array of options for the aggregation. */
    options: AggregationOption[]
    /** Description of the aggregation group */
    description: (Scalars['String'] | null)
    /** Description exists in Pimcore */
    hasDescription: Scalars['Boolean']
    __typename: 'Aggregation'
}


/** PageInfo provides navigation for the query response */
export interface PageInfo {
    /** Specifies which page of results to return */
    currentPage: Scalars['Int']
    /** Specifies the maximum number of items to return */
    pageSize: Scalars['Int']
    /** Total pages */
    totalPages: Scalars['Int']
    /** Total items */
    totalCount: Scalars['Int']
    __typename: 'PageInfo'
}


/** An object that includes the default sort field and all available sort fields. */
export interface SortFields {
    /** Default value of sort fields. */
    default: Scalars['String']
    /** Available sort fields. */
    options: SortField[]
    __typename: 'SortFields'
}

export interface SortField {
    /** Label of sort field. */
    label: Scalars['String']
    /** Attribute code of sort field. */
    value: Scalars['String']
    __typename: 'SortField'
}

export interface PanelType {
    shapes: Shape[]
    finishes: Finish[]
    variants: (ProductPagination | null)
    __typename: 'PanelType'
}

export interface SheetFurnitureType {
    cabinetOuterHeight: (Scalars['String'] | null)
    cabinetOuterWidth: (Scalars['String'] | null)
    cabinetOuterDepth: (Scalars['String'] | null)
    youtubeUrl: (Scalars['String'] | null)
    diyProjectCode: (Scalars['String'] | null)
    __typename: 'SheetFurnitureType'
}

export interface TableType {
    customTableToolJson: (Scalars['String'] | null)
    __typename: 'TableType'
}

export interface AccessoryType {
    shapes: ((Shape | null)[] | null)
    finishes: ((Finish | null)[] | null)
    __typename: 'AccessoryType'
}

export interface Shape {
    code: Scalars['String']
    name: Scalars['String']
    image: Scalars['String']
    description: (Scalars['String'] | null)
    __typename: 'Shape'
}

export interface Finish {
    code: Scalars['String']
    name: Scalars['String']
    image: Scalars['String']
    description: (Scalars['String'] | null)
    __typename: 'Finish'
}

export interface ImageGalleryType {
    alt: Scalars['String']
    src: Scalars['String']
    __typename: 'ImageGalleryType'
}

export interface VideosType {
    key: Scalars['String']
    label: Scalars['String']
    ids: (Scalars['String'] | null)
    __typename: 'VideosType'
}

export interface FurnitureToolStepsType {
    id: Scalars['String']
    name: Scalars['String']
    description: Scalars['String']
    __typename: 'FurnitureToolStepsType'
}

export interface FinishOption {
    code: Scalars['String']
    label: Scalars['String']
    image: Scalars['String']
    data: FinishOptionData[]
    __typename: 'FinishOption'
}

export interface FinishOptionData {
    code: Scalars['String']
    label: Scalars['String']
    value: Scalars['String']
    unit: Scalars['String']
    __typename: 'FinishOptionData'
}

export interface FinishSide {
    code: Scalars['String']
    label: Scalars['String']
    shortLabel: Scalars['String']
    __typename: 'FinishSide'
}

export type ProductType = (PanelType | SheetFurnitureType | TableType | AccessoryType) & { __isUnion?: true }

export interface ProductsPerPage {
    /** Default value of per page. */
    default: Scalars['Int']
    /** Available per page values. */
    options: (Scalars['Int'] | null)[]
    __typename: 'ProductsPerPage'
}

export interface GridPerPage {
    /** Default value of per page. */
    default: Scalars['Int']
    /** Available per page values. */
    options: (Scalars['Int'] | null)[]
    __typename: 'GridPerPage'
}

export interface HrefLang {
    href: Scalars['String']
    hreflang: Scalars['String']
    __typename: 'HrefLang'
}

export interface Asset {
    id: Scalars['ID']
    filename: Scalars['String']
    path: Scalars['String']
    __typename: 'Asset'
}

export interface SpecificationSheet {
    element: Asset
    variant: (Scalars['String'] | null)
    __typename: 'SpecificationSheet'
}

export type PriceDisplay = 'INCLUDING_TAX' | 'EXCLUDING_TAX' | 'BOTH'

export interface EdgeBand {
    id: Scalars['ID']
    parentId: Scalars['ID']
    sku: Scalars['String']
    name: Scalars['String']
    thickness: Scalars['Float']
    width: Scalars['Float']
    minOrderLength: Scalars['Int']
    image: (Scalars['String'] | null)
    price: Money
    __typename: 'EdgeBand'
}

export interface EdgeBands {
    matching: EdgeBand[]
    collection: EdgeBandPagination
    __typename: 'EdgeBands'
}

export interface EdgeBandPagination {
    /** List of items on the current page */
    items: EdgeBand[]
    /** Number of total items selected by the query */
    total: Scalars['Int']
    /** Number of items returned per page */
    perPage: Scalars['Int']
    /** Current page of the cursor */
    currentPage: Scalars['Int']
    /** The last page (number of pages) */
    lastPage: Scalars['Int']
    /** Determines if cursor has more pages after the current page */
    hasMorePages: Scalars['Boolean']
    __typename: 'EdgeBandPagination'
}

export interface ShareCode {
    id: Scalars['ID']
    code: Scalars['String']
    url: Scalars['String']
    product: Product
    data: Scalars['String']
    __typename: 'ShareCode'
}

export interface Contact {
    /** Flag if the form is send successfully */
    success: Scalars['Boolean']
    message: Scalars['String']
    __typename: 'Contact'
}

export interface ContactSettings {
    subjects: ((ContactSubject | null)[] | null)
    __typename: 'ContactSettings'
}

export interface ContactSubject {
    label: (Scalars['String'] | null)
    value: (Scalars['String'] | null)
    category: (Scalars['String'] | null)
    __typename: 'ContactSubject'
}


/** Checks if the order can be edited by the customer */
export interface OrderEditable {
    editable: Scalars['Boolean']
    message: Scalars['String']
    __typename: 'OrderEditable'
}

export interface CustomerToken {
    token: (Scalars['String'] | null)
    __typename: 'CustomerToken'
}


/** CustomerAddress contains detailed information about a customer's billing and shipping addresses */
export interface CustomerAddress {
    /** The city or town */
    city: (Scalars['String'] | null)
    /** The company */
    company: (Scalars['String'] | null)
    country: (CartAddressCountry | null)
    region: (CartAddressRegion | null)
    /** The first name of the person associated with the shipping/billing address */
    firstname: (Scalars['String'] | null)
    /** The last name of the person associated with the shipping/billing address */
    lastname: (Scalars['String'] | null)
    /** The customer's ZIP or postal code */
    postcode: (Scalars['String'] | null)
    street: (Scalars['String'] | null)
    street2: (Scalars['String'] | null)
    /** The telephone number */
    telephone: (Scalars['String'] | null)
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId: (Scalars['String'] | null)
    id: Scalars['ID']
    /** A label that the customer can assign to the address */
    label: (Scalars['String'] | null)
    /** Indicates whether the address is the default billing address */
    isDefaultBilling: (Scalars['Boolean'] | null)
    /** Indicates whether the address is the default shipping address */
    isDefaultShipping: (Scalars['Boolean'] | null)
    __typename: 'CustomerAddress'
}


/** Contains details about each of the customer's orders */
export interface CustomerOrder {
    incrementId: Scalars['ID']
    poNumber: (Scalars['String'] | null)
    /** The current status of the order */
    status: (Scalars['String'] | null)
    statusLabel: (Scalars['String'] | null)
    /** A field that can output a date in all sorts of ways. */
    orderDate: (Scalars['String'] | null)
    shippingDescription: (Scalars['String'] | null)
    /** A field that can output a date in all sorts of ways. */
    deliveryDate: (Scalars['String'] | null)
    invoiceDownloadUrl: (Scalars['String'] | null)
    /** A list of invoices for the order */
    invoices: Invoice[]
    /** A list of credit memos for the order */
    creditMemos: CreditMemo[]
    creditDownloadUrl: (Scalars['String'] | null)
    /** A list of shipments for the order */
    shipments: Shipment[]
    shipmentDownloadUrl: (Scalars['String'] | null)
    tracking: Tracking[]
    /** The billing address for the order */
    billingAddress: (OrderAddress | null)
    /** The shipping address for the order */
    shippingAddress: (OrderAddress | null)
    /** Contains totals of the customer's orders */
    totals: OrderTotals
    /** The total quantity of all products in the order */
    totalQtyOrdered: Scalars['Int']
    /** The selected payment method for the order */
    selectedPaymentMethod: (SelectedPaymentMethod | null)
    items: OrderItem[]
    /** The email address of the customer */
    email: (Scalars['String'] | null)
    /** Whether the order is editable */
    isEditable: Scalars['Boolean']
    cartQuote: (CartQuote | null)
    __typename: 'CustomerOrder'
}


/** Customer defines the customer name and address and other details */
export interface Customer {
    id: Scalars['ID']
    email: Scalars['String']
    firstname: (Scalars['String'] | null)
    lastname: (Scalars['String'] | null)
    phone: (Scalars['String'] | null)
    invoiceEmail: (Scalars['String'] | null)
    company: (Scalars['String'] | null)
    taxvat: (Scalars['String'] | null)
    legalFormType: (Scalars['String'] | null)
    registrationNumber: (Scalars['String'] | null)
    registrarName: (Scalars['String'] | null)
    /** The customer's date of birth */
    dob: (Scalars['String'] | null)
    /** The customer's gender */
    gender: (Gender | null)
    projects: CustomerProjectPagination
    /** An array containing the customer's shipping and billing addresses */
    addresses: CustomerAddress[]
    orders: (CustomerOrderPagination | null)
    /** The customer's wishlist */
    wishlist: (Wishlist | null)
    businessStatus: (BusinessStatus | null)
    __typename: 'Customer'
}

export interface CustomerProjectPagination {
    /** List of items on the current page */
    items: CustomerProject[]
    /** Number of total items selected by the query */
    total: Scalars['Int']
    /** Number of items returned per page */
    perPage: Scalars['Int']
    /** Current page of the cursor */
    currentPage: Scalars['Int']
    /** The last page (number of pages) */
    lastPage: Scalars['Int']
    /** Determines if cursor has more pages after the current page */
    hasMorePages: Scalars['Boolean']
    __typename: 'CustomerProjectPagination'
}

export interface CustomerProjectItemPagination {
    /** List of items on the current page */
    items: CustomerProjectItem[]
    /** Number of total items selected by the query */
    total: Scalars['Int']
    /** Number of items returned per page */
    perPage: Scalars['Int']
    /** Current page of the cursor */
    currentPage: Scalars['Int']
    /** The last page (number of pages) */
    lastPage: Scalars['Int']
    /** Determines if cursor has more pages after the current page */
    hasMorePages: Scalars['Boolean']
    __typename: 'CustomerProjectItemPagination'
}

export interface CustomerOrderPagination {
    /** List of items on the current page */
    items: CustomerOrder[]
    /** Number of total items selected by the query */
    total: Scalars['Int']
    /** Number of items returned per page */
    perPage: Scalars['Int']
    /** Current page of the cursor */
    currentPage: Scalars['Int']
    /** The last page (number of pages) */
    lastPage: Scalars['Int']
    /** Determines if cursor has more pages after the current page */
    hasMorePages: Scalars['Boolean']
    __typename: 'CustomerOrderPagination'
}

export interface Wishlist {
    id: Scalars['ID']
    products: Product[]
    __typename: 'Wishlist'
}

export type Gender = 'MALE' | 'FEMALE'

export type CustomerProjectStatus = 'ACTIVE' | 'ARCHIVED' | 'DELETED'

export type BusinessStatus = 'ACCEPTED' | 'DECLINED' | 'PENDING'


/** Contains details about customer's vat number */
export interface CustomerVat {
    companyName: (Scalars['String'] | null)
    isValid: (Scalars['Boolean'] | null)
    __typename: 'CustomerVat'
}


/** List of autocomplete results based on user input */
export interface AddressSuggestionResult {
    value: Scalars['String']
    label: Scalars['String']
    description: Scalars['String']
    precision: Scalars['String']
    context: Scalars['String']
    highlights: Scalars['String']
    __typename: 'AddressSuggestionResult'
}


/** List of autocomplete results based on user input */
export interface AddressSuggestionDetailResult {
    valid: Scalars['Boolean']
    city: Scalars['String']
    street: Scalars['String']
    postcode: Scalars['String']
    number: Scalars['String']
    numberAddition: (Scalars['String'] | null)
    __typename: 'AddressSuggestionDetailResult'
}

export interface CustomerProject {
    id: Scalars['ID']
    name: Scalars['String']
    notes: (Scalars['String'] | null)
    customer: Customer
    items: CustomerProjectItemPagination
    status: CustomerProjectStatus
    createdAt: Scalars['String']
    updatedAt: Scalars['String']
    __typename: 'CustomerProject'
}

export interface CustomerProjectItem {
    id: Scalars['ID']
    product: Product
    specs: (ItemSpecifications | null)
    quantity: Scalars['Int']
    orderData: (Scalars['String'] | null)
    __typename: 'CustomerProjectItem'
}

export interface Tracking {
    url: Scalars['String']
    label: Scalars['String']
    __typename: 'Tracking'
}

export interface Furniture {
    saleableProductId: (Scalars['Int'] | null)
    prices: FurniturePrice[]
    materials: FurnitureMaterial[]
    __typename: 'Furniture'
}

export interface FurnitureConstraints {
    width: FurnitureConstraint
    height: FurnitureConstraint
    depth: FurnitureConstraint
    __typename: 'FurnitureConstraints'
}

export interface FurnitureConstraint {
    min: (Scalars['Int'] | null)
    max: (Scalars['Int'] | null)
    __typename: 'FurnitureConstraint'
}

export interface FurniturePrice {
    label: Scalars['String']
    value: Scalars['Float']
    __typename: 'FurniturePrice'
}

export interface FurnitureMaterial {
    id: Scalars['ID']
    name: Scalars['String']
    description: (Scalars['String'] | null)
    product: (Product | null)
    thicknesses: ((FurnitureThickness | null)[] | null)
    __typename: 'FurnitureMaterial'
}

export interface FurnitureThickness {
    name: Scalars['String']
    sku: Scalars['String']
    parts: FurnitureThicknessParts
    __typename: 'FurnitureThickness'
}

export interface FurnitureThicknessParts {
    vertical: FurnitureThicknessPartData
    horizontal: FurnitureThicknessPartData
    door: FurnitureThicknessPartData
    shelf: FurnitureThicknessPartData
    background: FurnitureThicknessPartData
    __typename: 'FurnitureThicknessParts'
}

export interface FurnitureThicknessPartData {
    thickness: Scalars['String']
    price: Scalars['Float']
    constraints: FurnitureConstraints
    __typename: 'FurnitureThicknessPartData'
}

export interface KiyohReview {
    id: Scalars['ID']
    name: Scalars['String']
    place: (Scalars['String'] | null)
    date: Scalars['String']
    totalScore: Scalars['Float']
    reviewScore: Scalars['Int']
    positive: (Scalars['String'] | null)
    __typename: 'KiyohReview'
}

export interface KiyohInformation {
    totalScore: (Scalars['Float'] | null)
    reviewCount: (Scalars['Float'] | null)
    url: (Scalars['String'] | null)
    reviewUrl: (Scalars['String'] | null)
    __typename: 'KiyohInformation'
}

export interface CartQuote {
    id: Scalars['ID']
    incrementId: (Scalars['String'] | null)
    hash: Scalars['String']
    createdAt: (Scalars['String'] | null)
    products: CartQuoteProduct[]
    refundAmount: (Money | null)
    projectUrl: (Scalars['String'] | null)
    totalPrice: Money
    totalQuantity: Scalars['Int']
    firstname: (Scalars['String'] | null)
    country: Scalars['String']
    cartGroup: CartGroup[]
    isSalable: Scalars['Boolean']
    __typename: 'CartQuote'
}

export type CartQuoteProduct = (CartItem | OrderItem) & { __isUnion?: true }

export type MergeMethod = 'COMBINE' | 'KEEP_NEW'

export interface ShippingInformation {
    carrierCode: Scalars['String']
    carrierName: Scalars['String']
    carrierDescription: (Scalars['String'] | null)
    __typename: 'ShippingInformation'
}

export interface Query {
    /** The countries query provides information for all countries. */
    countries: (Country | null)[]
    /** The country query provides information for a single country. */
    country: (Country | null)
    /** Handles server side tracking events for Google Analytics based on locale-specific configurations. */
    tracking: Scalars['Boolean']
    website: Website
    /** Returns information about shopping cart */
    cart: (Cart | null)
    /** Returns information about the customer shopping cart */
    customerCart: Cart
    /** Returns status information about order */
    orderStatus: (CustomerOrder | null)
    /** Returns information about a single order */
    orderSuccess: (OrderSuccess | null)
    /** Calculate the price of an item */
    calculatePrice: Money
    products: Products
    product: (Product | null)
    category: (Category | null)
    search: (Products | null)
    urlResolver: (UrlResolverResult | null)
    bestSellers: (ProductPagination | null)
    filterableAttributes: Scalars['String'][]
    edgeBands: (EdgeBands | null)
    edgeBand: (EdgeBand | null)
    shareCode: (ShareCode | null)
    contactSettings: (ContactSettings | null)
    orderEditable: (OrderEditable | null)
    isEmailAvailable: Scalars['Boolean']
    addressSuggestions: ((AddressSuggestionResult | null)[] | null)
    addressSuggestionDetail: (AddressSuggestionDetailResult | null)
    customer: (Customer | null)
    customerOrder: (CustomerOrder | null)
    customerProject: (CustomerProject | null)
    furniture: Furniture
    kiyohReviews: (KiyohReviewPagination | null)
    cartQuote: (CartQuote | null)
    /** Returns information about available shipping methods */
    shippingInformation: ((ShippingInformation | null)[] | null)
    __typename: 'Query'
}

export interface KiyohReviewPagination {
    /** List of items on the current page */
    items: KiyohReview[]
    /** Number of total items selected by the query */
    total: Scalars['Int']
    /** Number of items returned per page */
    perPage: Scalars['Int']
    /** Current page of the cursor */
    currentPage: Scalars['Int']
    /** The last page (number of pages) */
    lastPage: Scalars['Int']
    /** Determines if cursor has more pages after the current page */
    hasMorePages: Scalars['Boolean']
    __typename: 'KiyohReviewPagination'
}

export interface Mutation {
    /** Add any type of product to the cart */
    addProductToCart: UpdateCartResult
    /** Creates an empty shopping cart for a guest or logged in user */
    createEmptyCart: Scalars['String']
    placeOrder: PlaceOrderOutput
    removeItemFromCart: UpdateCartResult
    setBillingAddressOnCart: Cart
    setCustomerEmailOnCart: Cart
    setPaymentMethodOnCart: Cart
    setShippingAddressOnCart: Cart
    setShippingMethodOnCart: Cart
    /** Update the item in the cart */
    updateCartItem: UpdateCartResult
    /** Update the orderdata of the item */
    updateOrderData: UpdateCartResult
    /** Update the sort order of items in the cart */
    updateCartSortOrder: Cart
    removeCouponFromCart: Cart
    applyCouponToCart: Cart
    clearCart: Cart
    /** Merges the source cart into the destination cart */
    mergeCarts: Cart
    optimizeItem: Cart
    toggleUseRestPieces: Cart
    /** Creates a new CSV to import later */
    createImportCsv: (Scalars['String'] | null)
    /** Sends a alert when product is back in stock. */
    productAlert: (Contact | null)
    createShareCode: ShareCode
    /** Send contact form and add FD ticket. */
    sendContact: (Contact | null)
    /** Sends a ticket to Freshdesk for the order edit form. */
    editOrderRequest: (Contact | null)
    /** Sends a ticket to Freshdesk for the order edit form. */
    sendStylistContact: (Contact | null)
    /** Sends a email to the customer service for bloggers form */
    sendBloggersContact: (Contact | null)
    /** Retrieve the customer token */
    generateCustomerToken: (CustomerToken | null)
    /** Request an email with a reset password token for the registered customer identified by the specified email. */
    requestPasswordResetEmail: (Scalars['Boolean'] | null)
    /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using requestPasswordResetEmail. */
    resetPassword: (Scalars['Boolean'] | null)
    /** Update the customer's email */
    updateCustomerEmail: (Customer | null)
    /** Update the customer's personal information */
    updateCustomer: (Customer | null)
    /** Create customer account */
    createCustomer: (Customer | null)
    /** Changes the password for the logged-in customer */
    changeCustomerPassword: (Customer | null)
    /** Create customer address */
    createCustomerAddress: (Customer | null)
    /** Delete customer address */
    deleteCustomerAddress: (Customer | null)
    /** Update customer address */
    updateCustomerAddress: (Customer | null)
    /** Validate the customer's VAT number */
    validateCustomerVat: (CustomerVat | null)
    removeProductFromWishlist: (Wishlist | null)
    addProductToWishlist: (Wishlist | null)
    /** Delete customer project */
    deleteCustomerProject: CustomerProject
    createCustomerProjectFromCart: CustomerProject
    createCustomerProjectFromItem: CustomerProject
    addCustomerProjectToCart: Cart
    applyForBusinessAccount: Customer
    updateCustomerProject: CustomerProject
    updateCustomerProjectItem: CustomerProjectItem
    addCartQuoteToCart: (Cart | null)
    createSharableCart: (Scalars['String'] | null)
    __typename: 'Mutation'
}

export interface AddressInterfaceGenqlSelection{
    /** The city or town */
    city?: boolean | number
    /** The company */
    company?: boolean | number
    country?: CartAddressCountryGenqlSelection
    region?: CartAddressRegionGenqlSelection
    /** The first name of the person associated with the shipping/billing address */
    firstname?: boolean | number
    /** The last name of the person associated with the shipping/billing address */
    lastname?: boolean | number
    /** The customer's ZIP or postal code */
    postcode?: boolean | number
    /** An string that defines the street number and name */
    street?: boolean | number
    /** The second line of the street address */
    street2?: boolean | number
    /** The telephone number */
    telephone?: boolean | number
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId?: boolean | number
    on_BillingCartAddress?: BillingCartAddressGenqlSelection
    on_ShippingCartAddress?: ShippingCartAddressGenqlSelection
    on_OrderAddress?: OrderAddressGenqlSelection
    on_CustomerAddress?: CustomerAddressGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StoreInformationGenqlSelection{
    code?: boolean | number
    /** The name of the current store */
    name?: boolean | number
    /** The name of the company */
    companyName?: boolean | number
    /** The locale of the current store */
    locale?: boolean | number
    /** The language of the current store */
    language?: boolean | number
    /** Two letter abbreviation of language of the current store */
    languageTwoLetterAbbreviation?: boolean | number
    /** The country of the current store */
    country?: CountryGenqlSelection
    /** The available countries of the current store */
    countries?: CountryGenqlSelection
    /** The root category of the current store */
    rootCategory?: CategoryGenqlSelection
    /** The base url of the current store */
    baseUrl?: boolean | number
    /** The timezone of the current store */
    timezone?: boolean | number
    /** The currency code of the current store */
    currency?: boolean | number
    customerService?: CustomerServiceGenqlSelection
    kiyoh?: KiyohInformationGenqlSelection
    companyVideo?: boolean | number
    /** @deprecated Facebook is being deprecated */
    facebook?: FacebookInformationGenqlSelection
    paymentMethods?: AvailablePaymentMethodGenqlSelection
    addressValidationAvailable?: boolean | number
    isCheckModeEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerServiceGenqlSelection{
    /** The status of the customer service */
    isOpen?: boolean | number
    /** A random image of a customer service employee */
    image?: boolean | number
    /** An information message to display */
    closeMessage?: boolean | number
    /** The time when the customer service opens */
    openTime?: boolean | number
    /** The time when the customer service closes */
    closeTime?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CountryGenqlSelection{
    availableRegions?: RegionGenqlSelection
    regionRequired?: boolean | number
    fullNameLocale?: boolean | number
    /** The unique ID for a Country object. */
    id?: boolean | number
    threeLetterAbbreviation?: boolean | number
    twoLetterAbbreviation?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RegionGenqlSelection{
    code?: boolean | number
    /** The unique ID for a Region object. */
    id?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacebookInformationGenqlSelection{
    facebookLikes?: boolean | number
    pageId?: boolean | number
    chatEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WebsiteGenqlSelection{
    /** The current store view */
    current?: StoreInformationGenqlSelection
    /** The the available store views */
    available?: StoreInformationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TrackingEventsInput {name: Scalars['String'],params: TrackingEventParamsInput[]}

export interface TrackingEventParamsInput {key: Scalars['String'],value: Scalars['String']}

export interface BillingAddressInput {cartId: Scalars['ID'],customerAddressId?: (Scalars['ID'] | null),address?: (CartAddressInput | null)}

export interface CartAddressInput {city?: (Scalars['String'] | null),countryCode?: (Scalars['String'] | null),region?: (Scalars['String'] | null),firstname?: (Scalars['String'] | null),lastname?: (Scalars['String'] | null),email?: (Scalars['String'] | null),postcode?: (Scalars['String'] | null),street?: (Scalars['String'] | null),street2?: (Scalars['String'] | null),telephone?: (Scalars['String'] | null),company?: (Scalars['String'] | null),vatId?: (Scalars['String'] | null)}

export interface CartItemInput {id: Scalars['ID'],quantity: Scalars['Int'],type?: (CartItemTypeEnum | null),data?: (Scalars['String'] | null),files?: ((Scalars['Upload'] | null)[] | null)}

export interface PlaceOrderInput {cartId: Scalars['ID'],orderComment?: (Scalars['String'] | null),poNumber?: (Scalars['String'] | null),orderNewsletter?: (Scalars['Boolean'] | null)}

export interface SetPaymentMethodOnCartInput {cartId: Scalars['ID'],paymentMethod: PaymentMethodInput}

export interface PaymentMethodInput {code: Scalars['String'],optionSub?: (Scalars['String'] | null)}

export interface SetShippingMethodOnCartInput {cartId: Scalars['ID'],shippingMethod: ShippingMethodInput,shippingComment?: (Scalars['String'] | null)}

export interface ShippingMethodInput {methodCode: Scalars['String'],deliveryDate?: (Scalars['String'] | null)}

export interface ShippingAddressInput {cartId: Scalars['ID'],customerAddressId?: (Scalars['ID'] | null),address?: (CartAddressInput | null),sameAsBilling?: (Scalars['Boolean'] | null)}

export interface UpdateCartInput {cartId: Scalars['ID'],cartItem: CartItemInput}

export interface UpdateOrderDataInput {cartId: Scalars['ID'],cartItemId: Scalars['ID'],orderData: Scalars['String']}

export interface CartItemSortOrderInput {id: Scalars['ID'],sortOrder: Scalars['Int']}

export interface UpdateCartSortOrderInput {cartId: Scalars['ID'],cartItems: (CartItemSortOrderInput | null)[]}

export interface PaymentMethodInterfaceGenqlSelection{
    code?: boolean | number
    title?: boolean | number
    logo?: boolean | number
    paymentCharge?: boolean | number
    paymentChargeTotal?: MoneyGenqlSelection
    paymentChargeType?: boolean | number
    on_AvailablePaymentMethod?: AvailablePaymentMethodGenqlSelection
    on_SelectedPaymentMethod?: SelectedPaymentMethodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingMethodInterfaceGenqlSelection{
    /** A shipping method code associated with a carrier. */
    methodCode?: boolean | number
    /** The label for the method code. */
    methodTitle?: boolean | number
    /** Deprecated */
    offsetLabel?: boolean | number
    /** The cost of shipping using this shipping method, including tax */
    price?: MoneyGenqlSelection
    description?: boolean | number
    /** Get the opening hours of take away location */
    openingHours?: boolean | number
    /** Check if dates are available */
    hasSelectableDate?: boolean | number
    /** Check if the user can select a date */
    datesEnabled?: boolean | number
    /** First available delivery date */
    firstAvailableDeliveryDate?: boolean | number
    /** Last available delivery date */
    lastAvailableDeliveryDate?: boolean | number
    /** Check if delivery instructions are available */
    hasDeliveryInstructions?: boolean | number
    /** Delivery instructions comment */
    deliveryInstructionsComment?: boolean | number
    on_SelectedShippingMethod?: SelectedShippingMethodGenqlSelection
    on_AvailableShippingMethod?: AvailableShippingMethodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AvailablePaymentMethodGenqlSelection{
    code?: boolean | number
    title?: boolean | number
    logo?: boolean | number
    paymentCharge?: boolean | number
    paymentChargeTotal?: MoneyGenqlSelection
    paymentChargeType?: boolean | number
    description?: boolean | number
    options?: PaymentOptionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillingCartAddressGenqlSelection{
    /** The city or town */
    city?: boolean | number
    /** The company */
    company?: boolean | number
    country?: CartAddressCountryGenqlSelection
    region?: CartAddressRegionGenqlSelection
    /** The first name of the person associated with the shipping/billing address */
    firstname?: boolean | number
    /** The last name of the person associated with the shipping/billing address */
    lastname?: boolean | number
    /** The customer's ZIP or postal code */
    postcode?: boolean | number
    street?: boolean | number
    street2?: boolean | number
    /** The telephone number */
    telephone?: boolean | number
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId?: boolean | number
    id?: boolean | number
    customerAddressId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartAddressCountryGenqlSelection{
    code?: boolean | number
    label?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartAddressRegionGenqlSelection{
    code?: boolean | number
    label?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartItemGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    description?: boolean | number
    image?: boolean | number
    sortOrder?: boolean | number
    parent?: CartItemGenqlSelection
    children?: CartItemGenqlSelection
    product?: ProductGenqlSelection
    quantity?: boolean | number
    group?: boolean | number
    specs?: ItemSpecificationsGenqlSelection
    orderData?: boolean | number
    isOptimized?: boolean | number
    reservedUntil?: boolean | number
    totals?: CartItemTotalsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductPaginationGenqlSelection{
    /** List of items on the current page */
    items?: ProductGenqlSelection
    /** Number of total items selected by the query */
    total?: boolean | number
    /** Number of items returned per page */
    perPage?: boolean | number
    /** Current page of the cursor */
    currentPage?: boolean | number
    /** The last page (number of pages) */
    lastPage?: boolean | number
    /** Determines if cursor has more pages after the current page */
    hasMorePages?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartGroupGenqlSelection{
    /** cart group code */
    id?: boolean | number
    /** Name of the cart group */
    name?: boolean | number
    /** Link to cart group type */
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartItemTotalsGenqlSelection{
    price?: MoneyGenqlSelection
    rowTotal?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartGenqlSelection{
    id?: boolean | number
    customerEmail?: boolean | number
    customerPhone?: boolean | number
    customerCompany?: boolean | number
    customerTaxvat?: boolean | number
    customerInvoiceEmail?: boolean | number
    customerComment?: boolean | number
    shippingComment?: boolean | number
    updatedAt?: boolean | number
    totalQuantity?: boolean | number
    billingAddress?: BillingCartAddressGenqlSelection
    shippingAddress?: ShippingCartAddressGenqlSelection
    items?: CartItemGenqlSelection
    appliedCoupon?: boolean | number
    isVirtual?: boolean | number
    totals?: CartTotalsGenqlSelection
    selectedPaymentMethod?: SelectedPaymentMethodGenqlSelection
    availablePaymentMethods?: AvailablePaymentMethodGenqlSelection
    cartGroup?: CartGroupGenqlSelection
    useRestPieces?: boolean | number
    orderComment?: boolean | number
    poNumber?: boolean | number
    orderNewsletter?: boolean | number
    crosssellProducts?: (ProductPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartTotalsGenqlSelection{
    grandTotal?: PriceLabelGenqlSelection
    subTotal?: PriceLabelGenqlSelection
    shipping?: PriceLabelGenqlSelection
    tax?: PriceLabelGenqlSelection
    taxPercentage?: boolean | number
    discount?: PriceLabelGenqlSelection
    paymentCharge?: PriceLabelGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderItemTotalsGenqlSelection{
    price?: MoneyGenqlSelection
    rowTotal?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PriceLabelGenqlSelection{
    label?: boolean | number
    price?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** A Money object defines a monetary value, including a numeric value and a currency code. */
export interface MoneyGenqlSelection{
    /** A three-letter currency code, such as USD or EUR */
    currency?: boolean | number
    display?: boolean | number
    includingTax?: boolean | number
    excludingTax?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentOptionGenqlSelection{
    optionId?: boolean | number
    name?: boolean | number
    logo?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PlaceOrderOutputGenqlSelection{
    orderNumber?: boolean | number
    url?: boolean | number
    monduToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SelectedPaymentMethodGenqlSelection{
    code?: boolean | number
    title?: boolean | number
    logo?: boolean | number
    paymentCharge?: boolean | number
    paymentChargeTotal?: MoneyGenqlSelection
    paymentChargeType?: boolean | number
    description?: boolean | number
    option?: PaymentOptionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingCartAddressGenqlSelection{
    /** The city or town */
    city?: boolean | number
    /** The company */
    company?: boolean | number
    country?: CartAddressCountryGenqlSelection
    region?: CartAddressRegionGenqlSelection
    /** The first name of the person associated with the shipping/billing address */
    firstname?: boolean | number
    /** The last name of the person associated with the shipping/billing address */
    lastname?: boolean | number
    /** The customer's ZIP or postal code */
    postcode?: boolean | number
    street?: boolean | number
    street2?: boolean | number
    /** The telephone number */
    telephone?: boolean | number
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId?: boolean | number
    id?: boolean | number
    customerAddressId?: boolean | number
    sameAsBilling?: boolean | number
    availableShippingMethods?: ShippingCarrierGenqlSelection
    selectedShippingMethod?: SelectedShippingCarrierGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingCarrierGenqlSelection{
    /** A string that identifies a commercial carrier or an offline shipping method. */
    carrierCode?: boolean | number
    /** The label for the carrier code. */
    carrierTitle?: boolean | number
    isTakeaway?: boolean | number
    /** The description of the method */
    description?: boolean | number
    banner?: boolean | number
    methods?: AvailableShippingMethodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SelectedShippingCarrierGenqlSelection{
    /** A string that identifies a commercial carrier or an offline shipping method. */
    carrierCode?: boolean | number
    /** The label for the carrier code. */
    carrierTitle?: boolean | number
    isTakeaway?: boolean | number
    /** The description of the method */
    description?: boolean | number
    banner?: boolean | number
    method?: SelectedShippingMethodGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SelectedShippingMethodGenqlSelection{
    /** A shipping method code associated with a carrier. */
    methodCode?: boolean | number
    /** The label for the method code. */
    methodTitle?: boolean | number
    /** Deprecated */
    offsetLabel?: boolean | number
    /** The cost of shipping using this shipping method, including tax */
    price?: MoneyGenqlSelection
    description?: boolean | number
    /** Get the opening hours of take away location */
    openingHours?: boolean | number
    /** Check if dates are available */
    hasSelectableDate?: boolean | number
    /** Check if the user can select a date */
    datesEnabled?: boolean | number
    /** First available delivery date */
    firstAvailableDeliveryDate?: boolean | number
    /** Last available delivery date */
    lastAvailableDeliveryDate?: boolean | number
    /** Check if delivery instructions are available */
    hasDeliveryInstructions?: boolean | number
    /** Delivery instructions comment */
    deliveryInstructionsComment?: boolean | number
    /** Selected delivery date */
    deliveryDate?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AvailableShippingMethodGenqlSelection{
    /** A shipping method code associated with a carrier. */
    methodCode?: boolean | number
    /** The label for the method code. */
    methodTitle?: boolean | number
    /** Deprecated */
    offsetLabel?: boolean | number
    /** The cost of shipping using this shipping method, including tax */
    price?: MoneyGenqlSelection
    description?: boolean | number
    /** Get the opening hours of take away location */
    openingHours?: boolean | number
    /** Check if dates are available */
    hasSelectableDate?: boolean | number
    /** Check if the user can select a date */
    datesEnabled?: boolean | number
    /** First available delivery date */
    firstAvailableDeliveryDate?: boolean | number
    /** Last available delivery date */
    lastAvailableDeliveryDate?: boolean | number
    /** Check if delivery instructions are available */
    hasDeliveryInstructions?: boolean | number
    /** Delivery instructions comment */
    deliveryInstructionsComment?: boolean | number
    /** Available delivery dates for the shipping method */
    deliveryDates?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateCartResultGenqlSelection{
    item?: CartItemGenqlSelection
    cart?: CartGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreditMemoGenqlSelection{
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShipmentGenqlSelection{
    id?: boolean | number
    tracking?: ShipmentTrackingGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShipmentTrackingGenqlSelection{
    id?: boolean | number
    carrier?: boolean | number
    title?: boolean | number
    number?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceGenqlSelection{
    id?: boolean | number
    total?: InvoiceTotalGenqlSelection
    downloadLink?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceTotalGenqlSelection{
    tax?: MoneyGenqlSelection
    shipping?: MoneyGenqlSelection
    subTotal?: MoneyGenqlSelection
    grandTotal?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** OrderAddress contains detailed information about an order's billing and shipping addresses */
export interface OrderAddressGenqlSelection{
    /** The city or town */
    city?: boolean | number
    /** The company */
    company?: boolean | number
    country?: CartAddressCountryGenqlSelection
    region?: CartAddressRegionGenqlSelection
    /** The first name of the person associated with the shipping/billing address */
    firstname?: boolean | number
    /** The last name of the person associated with the shipping/billing address */
    lastname?: boolean | number
    /** The customer's ZIP or postal code */
    postcode?: boolean | number
    street?: boolean | number
    /** The second line of the street address */
    street2?: boolean | number
    /** The telephone number */
    telephone?: boolean | number
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId?: boolean | number
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Contains totals of the order */
export interface OrderTotalsGenqlSelection{
    /** Order subtotal including tax */
    subTotal?: MoneyGenqlSelection
    shipping?: MoneyGenqlSelection
    discount?: MoneyGenqlSelection
    tax?: MoneyGenqlSelection
    taxPercentage?: boolean | number
    grandTotal?: MoneyGenqlSelection
    totalPaid?: MoneyGenqlSelection
    totalRefunded?: MoneyGenqlSelection
    totalDue?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrderItemGenqlSelection{
    id?: boolean | number
    sku?: boolean | number
    name?: boolean | number
    image?: boolean | number
    sortOrder?: boolean | number
    children?: OrderItemGenqlSelection
    product?: ProductGenqlSelection
    quantity?: boolean | number
    group?: boolean | number
    specs?: ItemSpecificationsGenqlSelection
    orderData?: boolean | number
    totals?: OrderItemTotalsGenqlSelection
    description?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Contains details about the order */
export interface OrderSuccessGenqlSelection{
    store?: StoreInformationGenqlSelection
    incrementId?: boolean | number
    email?: boolean | number
    deliveryDate?: boolean | number
    shippingDescription?: boolean | number
    isTakeaway?: boolean | number
    /** The shipping address for the order */
    shippingAddress?: OrderAddressGenqlSelection
    cartGroup?: CartGroupGenqlSelection
    items?: OrderItemGenqlSelection
    totals?: OrderTotalsGenqlSelection
    refundAmount?: MoneyGenqlSelection
    projectUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AppliedFinishGenqlSelection{
    finish?: FinishGenqlSelection
    option?: FinishOptionGenqlSelection
    side?: FinishSideGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DimensionsGenqlSelection{
    width?: boolean | number
    height?: boolean | number
    depth?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CabinetSpecsGenqlSelection{
    heading?: boolean | number
    data?: CabinetSpecsDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CabinetSpecsDataGenqlSelection{
    label?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WoodSpecificationGenqlSelection{
    dimensionsHtml?: boolean | number
    shape?: ShapeGenqlSelection
    finishes?: AppliedFinishGenqlSelection
    label?: boolean | number
    /** Dimensions of panel as used in Optimization without margins */
    optimizationDimensions?: OptimizationDimensionsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WoodCompleteSpecificationGenqlSelection{
    panelQuantity?: boolean | number
    optimizations?: OptimizationResultGenqlSelection
    shipBoards?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WoodCompleteRestSpecificationGenqlSelection{
    dimensionsHtml?: boolean | number
    shape?: ShapeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PlasticSpecificationGenqlSelection{
    dimensionsHtml?: boolean | number
    shape?: ShapeGenqlSelection
    finishes?: AppliedFinishGenqlSelection
    label?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SheetFurnitureSpecificationGenqlSelection{
    dimensions?: DimensionsGenqlSelection
    specs?: CabinetSpecsGenqlSelection
    dimensionsHtml?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TableSpecificationGenqlSelection{
    shape?: ShapeGenqlSelection
    finishes?: AppliedFinishGenqlSelection
    dimensionsHtml?: boolean | number
    topLayer?: boolean | number
    thickness?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FeeSpecificationGenqlSelection{
    attachments?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OptimizationResultGenqlSelection{
    length?: boolean | number
    width?: boolean | number
    panelLength?: boolean | number
    panelWidth?: boolean | number
    items?: OptimizationItemGenqlSelection
    boards?: OptimizationItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OptimizationItemGenqlSelection{
    id?: boolean | number
    length?: boolean | number
    width?: boolean | number
    x?: boolean | number
    y?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Dimensions of panel as used in Optimization without margins */
export interface OptimizationDimensionsGenqlSelection{
    length?: boolean | number
    width?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemSpecificationsGenqlSelection{
    on_WoodSpecification?:WoodSpecificationGenqlSelection,
    on_WoodCompleteSpecification?:WoodCompleteSpecificationGenqlSelection,
    on_WoodCompleteRestSpecification?:WoodCompleteRestSpecificationGenqlSelection,
    on_PlasticSpecification?:PlasticSpecificationGenqlSelection,
    on_TableSpecification?:TableSpecificationGenqlSelection,
    on_FeeSpecification?:FeeSpecificationGenqlSelection,
    on_SheetFurnitureSpecification?:SheetFurnitureSpecificationGenqlSelection,
    __typename?: boolean | number
}

export interface ProductsGenqlSelection{
    /** An array of products that match the specified search criteria. */
    items?: ProductGenqlSelection
    /** An object that includes the pageInfo and currentPage values specified in the query. */
    pageInfo?: PageInfoGenqlSelection
    /** An object that includes the default sort field and all available sort fields. */
    sortFields?: SortFieldsGenqlSelection
    listMode?: boolean | number
    /** An object that includes all the options for the grid per page filter */
    gridPerPage?: ProductsPerPageGenqlSelection
    /** An object that includes all the options for the list per page filter */
    listPerPage?: ProductsPerPageGenqlSelection
    /** Layered navigation aggregations */
    aggregations?: AggregationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductGenqlSelection{
    name?: boolean | number
    shortDescription?: boolean | number
    /** SKU */
    sku?: boolean | number
    price?: MoneyGenqlSelection
    specialPrice?: boolean | number
    specialFromDate?: boolean | number
    specialToDate?: boolean | number
    image?: boolean | number
    /** Small Image */
    smallImage?: boolean | number
    /** Thumbnail */
    thumbnail?: boolean | number
    newsFromDate?: boolean | number
    newsToDate?: boolean | number
    /** Status */
    status?: boolean | number
    urlKey?: boolean | number
    requiredOptions?: boolean | number
    imageLabel?: boolean | number
    smallImageLabel?: boolean | number
    thumbnailLabel?: boolean | number
    msrpEnabled?: boolean | number
    msrpDisplayActualPriceType?: boolean | number
    msrp?: boolean | number
    /** Tax Class */
    taxClassId?: boolean | number
    priceType?: boolean | number
    weightType?: boolean | number
    priceView?: boolean | number
    shipmentType?: boolean | number
    linksPurchasedSeparately?: boolean | number
    linksExist?: boolean | number
    /** Variant */
    typeFinish?: boolean | number
    /** Max. Width (mm) */
    maxWidth?: boolean | number
    /** Max. Length (mm) */
    maxLength?: boolean | number
    /** Thickness */
    thicknessOld?: boolean | number
    positiveNegative?: boolean | number
    /** Used wood */
    woodUsed?: boolean | number
    /** Dimension of unity */
    productUnit?: boolean | number
    /** Standard length in mm */
    standardLength?: boolean | number
    /** Standard width in mm */
    standardWidth?: boolean | number
    /** Width */
    width?: boolean | number
    /** Packaging unit */
    packagingUnit?: boolean | number
    /** Brand */
    brand?: boolean | number
    /** Depth */
    depth?: boolean | number
    /** Height */
    height?: boolean | number
    supplier?: boolean | number
    /** Headmaat */
    kopmaat?: boolean | number
    /** Color code */
    colorCode?: boolean | number
    /** Explanation of wood type at cupboards */
    woodExplanationFurniture?: boolean | number
    stockMessage?: boolean | number
    /** Grain */
    grainType?: boolean | number
    /** Top layer type */
    toplayerType?: boolean | number
    /** Hover image */
    hoverImage?: boolean | number
    /** Label text for cat. page */
    labelCategoryPage?: boolean | number
    appearance?: boolean | number
    /** Pas gordelomvang beperkingen toe van DPD. */
    applyBeltSize?: boolean | number
    pimImageBase?: boolean | number
    pimImageDetail?: boolean | number
    pimImageGallery?: boolean | number
    jsonConfiguration?: boolean | number
    productionUnit?: boolean | number
    cabinetOuterWidth?: boolean | number
    cabinetOuterDepth?: boolean | number
    cabinetOuterHeight?: boolean | number
    stockPosition?: boolean | number
    ncsColorCode?: boolean | number
    pmsColorCode?: boolean | number
    deliveryOffset?: boolean | number
    purchaseType?: boolean | number
    priceM2CompletePanel?: boolean | number
    deliveryTime?: boolean | number
    priceM2UncutPanel?: boolean | number
    thickness?: boolean | number
    diyProjectCode?: boolean | number
    id?: boolean | number
    finalPrice?: MoneyGenqlSelection
    lowestPrice?: MoneyGenqlSelection
    category?: CategoryGenqlSelection
    /** Category tree only to be used in product view */
    categories?: CategoryGenqlSelection
    faqCategoryIds?: boolean | number
    description?: boolean | number
    woodApplications?: boolean | number
    metaTitle?: boolean | number
    metaKeywords?: boolean | number
    metaDescription?: boolean | number
    hrefLang?: HrefLangGenqlSelection
    attributeSet?: boolean | number
    maxDimensions?: boolean | number
    fastestDeliveryDate?: boolean | number
    customStock?: boolean | number
    isSalable?: boolean | number
    configurable?: boolean | number
    url?: boolean | number
    attributes?: ProductAttributeGenqlSelection
    requestPath?: boolean | number
    productType?: ProductTypeGenqlSelection
    typeId?: boolean | number
    imageBase?: boolean | number
    imageDetail?: boolean | number
    imageGallery?: ImageGalleryTypeGenqlSelection
    videoGallery?: boolean | number
    groupedProductId?: boolean | number
    sampleProduct?: ProductGenqlSelection
    alternativeProduct?: ProductGenqlSelection
    crosssellProducts?: (ProductPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    associatedProducts?: (ProductPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    specificationSheets?: SpecificationSheetGenqlSelection
    isOnWishlist?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductAttributeGenqlSelection{
    code?: boolean | number
    label?: boolean | number
    value?: boolean | number
    optionId?: boolean | number
    description?: boolean | number
    hasDescription?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategoryGenqlSelection{
    /** URL KEY */
    urlKey?: boolean | number
    /** Description */
    description?: boolean | number
    image?: boolean | number
    /** Meta Title */
    metaTitle?: boolean | number
    metaKeywords?: boolean | number
    /** Meta Description */
    metaDescription?: boolean | number
    path?: boolean | number
    urlPath?: boolean | number
    seoContent?: boolean | number
    id?: boolean | number
    name?: boolean | number
    requestPath?: boolean | number
    url?: boolean | number
    hrefLang?: HrefLangGenqlSelection
    isUsedForSeo?: boolean | number
    displayType?: boolean | number
    hasChildren?: boolean | number
    children?: CategoryGenqlSelection
    parent?: CategoryGenqlSelection
    parents?: CategoryGenqlSelection
    level?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UrlResolverResultGenqlSelection{
    id?: boolean | number
    type?: boolean | number
    redirect?: boolean | number
    permanent?: boolean | number
    path?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** ProductAttributeFilterInput defines the filters to be used in the search. A filter contains at least one attribute and the value(s) that is being searched for. */
export interface ProductAttributeFilterInput {
/** Filter product by the unique ID for a CategoryInterface object. */
category_id?: (Scalars['ID'] | null),
/** Filter products by type (e.g. simple, grouped) */
type_id?: (Scalars['String'] | null),
/** Attribute label: Variant */
type_finish?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Kleur */
color?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Toepassing (klimaat) */
outdoor?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Houtsoort toplaag */
wood_used?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Beschikbare vormen */
finish_shapes?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Beschikbare afwerkingen */
finish_types?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Merk */
brand?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Schroefkop */
acc_bit_type?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Diameter */
acc_diameter?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Korrel */
acc_sandpaper_grain?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Kopmaat */
kopmaat?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Kleurcode */
color_code?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Type toplaag */
toplayer_type?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Structuur toplaag */
wood_structure?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Behandeling voor gebruik */
treatment_for_use?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Plaatopbouw */
wood_connection_type?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Zichtkwaliteit */
quality_visual?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Uitstraling */
appearance?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Productie verwerkingsmethode */
production_unit?: ((Scalars['String'] | null)[] | null),
/** Attribute label: NCS */
ncs_color_code?: ((Scalars['String'] | null)[] | null),
/** Attribute label: PMS */
pms_color_code?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Afname type */
purchase_type?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Levertijd */
delivery_time?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Functioneel gebruik */
general_application?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Kern */
core?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Kleurnuance */
color_shade?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Sample service */
sample_service?: ((Scalars['String'] | null)[] | null),
/** Attribute label: Dikte */
thickness?: ((Scalars['String'] | null)[] | null)}

export interface ProductAttributeSortInput {
/** Sort by Naam */
name?: (SortInput | null),
/** Sort by Prijs */
price?: (SortInput | null),
/** Sort by Levertijd */
delivery_time?: (SortInput | null)}

export interface AggregationOptionGenqlSelection{
    /** The number of items that match the aggregation option. */
    count?: boolean | number
    /** Aggregation option display label. */
    label?: boolean | number
    /** The internal ID that represents the value of the option. */
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** A bucket that contains information for each filterable option (such as price, category ID, and custom attributes). */
export interface AggregationGenqlSelection{
    /** Attribute code of the aggregation group. */
    attribute_code?: boolean | number
    /** The aggregation display name. */
    label?: boolean | number
    /** Array of options for the aggregation. */
    options?: AggregationOptionGenqlSelection
    /** Description of the aggregation group */
    description?: boolean | number
    /** Description exists in Pimcore */
    hasDescription?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** PageInfo provides navigation for the query response */
export interface PageInfoGenqlSelection{
    /** Specifies which page of results to return */
    currentPage?: boolean | number
    /** Specifies the maximum number of items to return */
    pageSize?: boolean | number
    /** Total pages */
    totalPages?: boolean | number
    /** Total items */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** An object that includes the default sort field and all available sort fields. */
export interface SortFieldsGenqlSelection{
    /** Default value of sort fields. */
    default?: boolean | number
    /** Available sort fields. */
    options?: SortFieldGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SortFieldGenqlSelection{
    /** Label of sort field. */
    label?: boolean | number
    /** Attribute code of sort field. */
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PanelTypeGenqlSelection{
    shapes?: ShapeGenqlSelection
    finishes?: FinishGenqlSelection
    variants?: (ProductPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SheetFurnitureTypeGenqlSelection{
    cabinetOuterHeight?: boolean | number
    cabinetOuterWidth?: boolean | number
    cabinetOuterDepth?: boolean | number
    youtubeUrl?: boolean | number
    diyProjectCode?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TableTypeGenqlSelection{
    customTableToolJson?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccessoryTypeGenqlSelection{
    shapes?: ShapeGenqlSelection
    finishes?: FinishGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShapeGenqlSelection{
    code?: boolean | number
    name?: boolean | number
    image?: boolean | number
    description?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinishGenqlSelection{
    code?: boolean | number
    name?: boolean | number
    image?: boolean | number
    description?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ImageGalleryTypeGenqlSelection{
    alt?: boolean | number
    src?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VideosTypeGenqlSelection{
    key?: boolean | number
    label?: boolean | number
    ids?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureToolStepsTypeGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    description?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinishOptionGenqlSelection{
    code?: boolean | number
    label?: boolean | number
    image?: boolean | number
    data?: FinishOptionDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinishOptionDataGenqlSelection{
    code?: boolean | number
    label?: boolean | number
    value?: boolean | number
    unit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinishSideGenqlSelection{
    code?: boolean | number
    label?: boolean | number
    shortLabel?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProductTypeGenqlSelection{
    on_PanelType?:PanelTypeGenqlSelection,
    on_SheetFurnitureType?:SheetFurnitureTypeGenqlSelection,
    on_TableType?:TableTypeGenqlSelection,
    on_AccessoryType?:AccessoryTypeGenqlSelection,
    __typename?: boolean | number
}

export interface ProductsPerPageGenqlSelection{
    /** Default value of per page. */
    default?: boolean | number
    /** Available per page values. */
    options?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GridPerPageGenqlSelection{
    /** Default value of per page. */
    default?: boolean | number
    /** Available per page values. */
    options?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HrefLangGenqlSelection{
    href?: boolean | number
    hreflang?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetGenqlSelection{
    id?: boolean | number
    filename?: boolean | number
    path?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SpecificationSheetGenqlSelection{
    element?: AssetGenqlSelection
    variant?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EdgeBandGenqlSelection{
    id?: boolean | number
    parentId?: boolean | number
    sku?: boolean | number
    name?: boolean | number
    thickness?: boolean | number
    width?: boolean | number
    minOrderLength?: boolean | number
    image?: boolean | number
    price?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EdgeBandsGenqlSelection{
    matching?: EdgeBandGenqlSelection
    collection?: EdgeBandPaginationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EdgeBandPaginationGenqlSelection{
    /** List of items on the current page */
    items?: EdgeBandGenqlSelection
    /** Number of total items selected by the query */
    total?: boolean | number
    /** Number of items returned per page */
    perPage?: boolean | number
    /** Current page of the cursor */
    currentPage?: boolean | number
    /** The last page (number of pages) */
    lastPage?: boolean | number
    /** Determines if cursor has more pages after the current page */
    hasMorePages?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShareCodeGenqlSelection{
    id?: boolean | number
    code?: boolean | number
    url?: boolean | number
    product?: ProductGenqlSelection
    data?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateShareCodeInput {reference?: (Scalars['String'] | null),name?: (Scalars['String'] | null),email: Scalars['String'],productId: Scalars['ID'],data: Scalars['String']}

export interface ContactGenqlSelection{
    /** Flag if the form is send successfully */
    success?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContactInput {type?: (Scalars['String'] | null),subject?: (Scalars['String'] | null),name: Scalars['String'],email: Scalars['String'],phone?: (Scalars['String'] | null),order_number?: (Scalars['String'] | null),url?: (Scalars['String'] | null),description: Scalars['String'],description_type?: (Scalars['String'] | null),company?: (Scalars['String'] | null),date?: (Scalars['String'] | null),solution?: (Scalars['String'] | null),solution_other?: (Scalars['String'] | null),com_preference?: (Scalars['String'] | null),call_time?: (Scalars['String'] | null),response_time?: (Scalars['String'] | null),delivery_date?: (Scalars['String'] | null),files?: ((Scalars['Upload'] | null)[] | null),product_type?: (Scalars['String'] | null),product_materials?: (Scalars['String'] | null),product_width?: (Scalars['Int'] | null),product_height?: (Scalars['Int'] | null),product_depth?: (Scalars['Int'] | null),product_thickness?: (Scalars['Int'] | null),product_urls?: ((Scalars['String'] | null)[] | null)}

export interface ContactSettingsGenqlSelection{
    subjects?: ContactSubjectGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContactSubjectGenqlSelection{
    label?: boolean | number
    value?: boolean | number
    category?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EditOrderRequestInput {email: Scalars['String'],ordernumber: Scalars['String'],type: Scalars['String'],date?: (Scalars['String'] | null),addressType?: (Scalars['String'] | null),description?: (Scalars['String'] | null),restpieces_delivery?: (Scalars['Boolean'] | null)}


/** Checks if the order can be edited by the customer */
export interface OrderEditableGenqlSelection{
    editable?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StylistContactInput {name?: (Scalars['String'] | null),email?: (Scalars['String'] | null),phone?: (Scalars['String'] | null),postal?: (Scalars['String'] | null),number?: (Scalars['String'] | null),description?: (Scalars['String'] | null),receiver?: (Scalars['String'] | null)}

export interface BloggersContactInput {name: Scalars['String'],email: Scalars['String'],tel: Scalars['String'],productType: Scalars['String'],content?: (Scalars['String'][] | null),url: Scalars['String'],socialMedia: SocialMediaInputType[],description: Scalars['String'],agreement?: (Scalars['Boolean'] | null)}

export interface SocialMediaInputType {channel: Scalars['String'],username: Scalars['String']}

export interface CustomerTokenGenqlSelection{
    token?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** CustomerAddress contains detailed information about a customer's billing and shipping addresses */
export interface CustomerAddressGenqlSelection{
    /** The city or town */
    city?: boolean | number
    /** The company */
    company?: boolean | number
    country?: CartAddressCountryGenqlSelection
    region?: CartAddressRegionGenqlSelection
    /** The first name of the person associated with the shipping/billing address */
    firstname?: boolean | number
    /** The last name of the person associated with the shipping/billing address */
    lastname?: boolean | number
    /** The customer's ZIP or postal code */
    postcode?: boolean | number
    street?: boolean | number
    street2?: boolean | number
    /** The telephone number */
    telephone?: boolean | number
    /** The customer's Tax/VAT number (for corporate customers) */
    vatId?: boolean | number
    id?: boolean | number
    /** A label that the customer can assign to the address */
    label?: boolean | number
    /** Indicates whether the address is the default billing address */
    isDefaultBilling?: boolean | number
    /** Indicates whether the address is the default shipping address */
    isDefaultShipping?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Contains details about each of the customer's orders */
export interface CustomerOrderGenqlSelection{
    incrementId?: boolean | number
    poNumber?: boolean | number
    /** The current status of the order */
    status?: boolean | number
    statusLabel?: boolean | number
    /** A field that can output a date in all sorts of ways. */
    orderDate?: { __args: {
    /** Defaults to D, d M Y H:i:s O */
    format?: (Scalars['String'] | null)} }
    shippingDescription?: boolean | number
    /** A field that can output a date in all sorts of ways. */
    deliveryDate?: { __args: {
    /** Defaults to D, d M Y H:i:s O */
    format?: (Scalars['String'] | null)} }
    invoiceDownloadUrl?: boolean | number
    /** A list of invoices for the order */
    invoices?: InvoiceGenqlSelection
    /** A list of credit memos for the order */
    creditMemos?: CreditMemoGenqlSelection
    creditDownloadUrl?: boolean | number
    /** A list of shipments for the order */
    shipments?: ShipmentGenqlSelection
    shipmentDownloadUrl?: boolean | number
    tracking?: TrackingGenqlSelection
    /** The billing address for the order */
    billingAddress?: OrderAddressGenqlSelection
    /** The shipping address for the order */
    shippingAddress?: OrderAddressGenqlSelection
    /** Contains totals of the customer's orders */
    totals?: OrderTotalsGenqlSelection
    /** The total quantity of all products in the order */
    totalQtyOrdered?: boolean | number
    /** The selected payment method for the order */
    selectedPaymentMethod?: SelectedPaymentMethodGenqlSelection
    items?: OrderItemGenqlSelection
    /** The email address of the customer */
    email?: boolean | number
    /** Whether the order is editable */
    isEditable?: boolean | number
    cartQuote?: CartQuoteGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Customer defines the customer name and address and other details */
export interface CustomerGenqlSelection{
    id?: boolean | number
    email?: boolean | number
    firstname?: boolean | number
    lastname?: boolean | number
    phone?: boolean | number
    invoiceEmail?: boolean | number
    company?: boolean | number
    taxvat?: boolean | number
    legalFormType?: boolean | number
    registrationNumber?: boolean | number
    registrarName?: boolean | number
    /** The customer's date of birth */
    dob?: { __args: {
    /** Defaults to D, d M Y H:i:s O */
    format?: (Scalars['String'] | null)} }
    /** The customer's gender */
    gender?: boolean | number
    projects?: (CustomerProjectPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null), status?: (CustomerProjectStatus | null)} })
    /** An array containing the customer's shipping and billing addresses */
    addresses?: CustomerAddressGenqlSelection
    orders?: (CustomerOrderPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    /** The customer's wishlist */
    wishlist?: WishlistGenqlSelection
    businessStatus?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerProjectPaginationGenqlSelection{
    /** List of items on the current page */
    items?: CustomerProjectGenqlSelection
    /** Number of total items selected by the query */
    total?: boolean | number
    /** Number of items returned per page */
    perPage?: boolean | number
    /** Current page of the cursor */
    currentPage?: boolean | number
    /** The last page (number of pages) */
    lastPage?: boolean | number
    /** Determines if cursor has more pages after the current page */
    hasMorePages?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerProjectItemPaginationGenqlSelection{
    /** List of items on the current page */
    items?: CustomerProjectItemGenqlSelection
    /** Number of total items selected by the query */
    total?: boolean | number
    /** Number of items returned per page */
    perPage?: boolean | number
    /** Current page of the cursor */
    currentPage?: boolean | number
    /** The last page (number of pages) */
    lastPage?: boolean | number
    /** Determines if cursor has more pages after the current page */
    hasMorePages?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerOrderPaginationGenqlSelection{
    /** List of items on the current page */
    items?: CustomerOrderGenqlSelection
    /** Number of total items selected by the query */
    total?: boolean | number
    /** Number of items returned per page */
    perPage?: boolean | number
    /** Current page of the cursor */
    currentPage?: boolean | number
    /** The last page (number of pages) */
    lastPage?: boolean | number
    /** Determines if cursor has more pages after the current page */
    hasMorePages?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WishlistGenqlSelection{
    id?: boolean | number
    products?: ProductGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UpdateCustomerInput {firstname: Scalars['String'],lastname: Scalars['String'],gender?: (Gender | null),dob?: (Scalars['String'] | null),company?: (Scalars['String'] | null),phone?: (Scalars['String'] | null),invoiceEmail?: (Scalars['String'] | null),legalFormType?: (Scalars['String'] | null),registrationNumber?: (Scalars['String'] | null),registrarName?: (Scalars['String'] | null),taxvat?: (Scalars['String'] | null)}

export interface CreateCustomerInput {
/** The customer's email */
email: Scalars['String'],
/** The customer's password */
password: Scalars['String'],
/** The customer's first name */
firstname: Scalars['String'],
/** The customer's last name */
lastname: Scalars['String'],
/** The customer's gender */
gender?: (Gender | null),
/** The customer's date of birth */
dob?: (Scalars['String'] | null)}

export interface CustomerAddressInput {country: Scalars['String'],region?: (Scalars['String'] | null),
/** Description of the address */
label?: (Scalars['String'] | null),
/** The first name of the person associated with the shipping/billing address */
firstname: Scalars['String'],
/** The last name of the person associated with the shipping/billing address */
lastname: Scalars['String'],
/** The customer's ZIP or postal code */
postcode: Scalars['String'],
/** The city or town */
city: Scalars['String'],
/** An string that defines the street number and name */
street: Scalars['String'],street2?: (Scalars['String'] | null),isDefaultBilling?: (Scalars['Boolean'] | null),isDefaultShipping?: (Scalars['Boolean'] | null)}

export interface ApplyForBusinessAccountInput {firstname: Scalars['String'],lastname: Scalars['String'],dob: Scalars['String'],company: Scalars['String'],phone: Scalars['String'],legalFormType: Scalars['String'],registrationNumber?: (Scalars['String'] | null),taxvat: Scalars['String'],addressInput: CustomerAddressInput}

export interface CustomerProjectInput {name: Scalars['String'],status: CustomerProjectStatus,notes?: (Scalars['String'] | null)}

export interface CustomerProjectItemInput {productId: Scalars['ID'],orderData: Scalars['String'],quantity: Scalars['Int']}


/** Contains details about customer's vat number */
export interface CustomerVatGenqlSelection{
    companyName?: boolean | number
    isValid?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** List of autocomplete results based on user input */
export interface AddressSuggestionResultGenqlSelection{
    value?: boolean | number
    label?: boolean | number
    description?: boolean | number
    precision?: boolean | number
    context?: boolean | number
    highlights?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** List of autocomplete results based on user input */
export interface AddressSuggestionDetailResultGenqlSelection{
    valid?: boolean | number
    city?: boolean | number
    street?: boolean | number
    postcode?: boolean | number
    number?: boolean | number
    numberAddition?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerProjectGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    notes?: boolean | number
    customer?: CustomerGenqlSelection
    items?: CustomerProjectItemPaginationGenqlSelection
    status?: boolean | number
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerProjectItemGenqlSelection{
    id?: boolean | number
    product?: ProductGenqlSelection
    specs?: ItemSpecificationsGenqlSelection
    quantity?: boolean | number
    orderData?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TrackingGenqlSelection{
    url?: boolean | number
    label?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureGenqlSelection{
    saleableProductId?: boolean | number
    prices?: FurniturePriceGenqlSelection
    materials?: FurnitureMaterialGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureConstraintsGenqlSelection{
    width?: FurnitureConstraintGenqlSelection
    height?: FurnitureConstraintGenqlSelection
    depth?: FurnitureConstraintGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureConstraintGenqlSelection{
    min?: boolean | number
    max?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurniturePriceGenqlSelection{
    label?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureMaterialGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    description?: boolean | number
    product?: ProductGenqlSelection
    thicknesses?: FurnitureThicknessGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureThicknessGenqlSelection{
    name?: boolean | number
    sku?: boolean | number
    parts?: FurnitureThicknessPartsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureThicknessPartsGenqlSelection{
    vertical?: FurnitureThicknessPartDataGenqlSelection
    horizontal?: FurnitureThicknessPartDataGenqlSelection
    door?: FurnitureThicknessPartDataGenqlSelection
    shelf?: FurnitureThicknessPartDataGenqlSelection
    background?: FurnitureThicknessPartDataGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FurnitureThicknessPartDataGenqlSelection{
    thickness?: boolean | number
    price?: boolean | number
    constraints?: FurnitureConstraintsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface KiyohReviewGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    place?: boolean | number
    date?: boolean | number
    totalScore?: boolean | number
    reviewScore?: boolean | number
    positive?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface KiyohInformationGenqlSelection{
    totalScore?: boolean | number
    reviewCount?: boolean | number
    url?: boolean | number
    reviewUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartQuoteGenqlSelection{
    id?: boolean | number
    incrementId?: boolean | number
    hash?: boolean | number
    createdAt?: boolean | number
    products?: CartQuoteProductGenqlSelection
    refundAmount?: MoneyGenqlSelection
    projectUrl?: boolean | number
    totalPrice?: MoneyGenqlSelection
    totalQuantity?: boolean | number
    firstname?: boolean | number
    country?: boolean | number
    cartGroup?: CartGroupGenqlSelection
    isSalable?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CartQuoteProductGenqlSelection{
    on_CartItem?:CartItemGenqlSelection,
    on_OrderItem?:OrderItemGenqlSelection,
    __typename?: boolean | number
}

export interface CreateSharableCartInput {cartId: Scalars['ID']}

export interface ShippingInformationGenqlSelection{
    carrierCode?: boolean | number
    carrierName?: boolean | number
    carrierDescription?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QueryGenqlSelection{
    /** The countries query provides information for all countries. */
    countries?: CountryGenqlSelection
    /** The country query provides information for a single country. */
    country?: (CountryGenqlSelection & { __args?: {id?: (Scalars['ID'] | null)} })
    /** Handles server side tracking events for Google Analytics based on locale-specific configurations. */
    tracking?: { __args: {clientId: Scalars['String'], userId?: (Scalars['String'] | null), events: TrackingEventsInput[]} }
    website?: WebsiteGenqlSelection
    /** Returns information about shopping cart */
    cart?: (CartGenqlSelection & { __args?: {id?: (Scalars['ID'] | null)} })
    /** Returns information about the customer shopping cart */
    customerCart?: CartGenqlSelection
    /** Returns status information about order */
    orderStatus?: (CustomerOrderGenqlSelection & { __args: {id: Scalars['ID'], email: Scalars['String']} })
    /** Returns information about a single order */
    orderSuccess?: (OrderSuccessGenqlSelection & { __args: {id: Scalars['ID']} })
    /** Calculate the price of an item */
    calculatePrice?: (MoneyGenqlSelection & { __args: {productId: Scalars['ID'], data: Scalars['String']} })
    products?: (ProductsGenqlSelection & { __args?: {pageSize?: (Scalars['Int'] | null), currentPage?: (Scalars['Int'] | null), filter?: (ProductAttributeFilterInput | null), sort?: (ProductAttributeSortInput | null), cartId?: (Scalars['ID'] | null)} })
    product?: (ProductGenqlSelection & { __args?: {id?: (Scalars['ID'] | null)} })
    category?: (CategoryGenqlSelection & { __args?: {id?: (Scalars['ID'] | null)} })
    search?: (ProductsGenqlSelection & { __args?: {search?: (Scalars['String'] | null), pageSize?: (Scalars['Int'] | null), currentPage?: (Scalars['Int'] | null), sort?: (ProductAttributeSortInput | null)} })
    urlResolver?: (UrlResolverResultGenqlSelection & { __args: {
    /** The requested URL. The url value must contain the URL key and suffix. */
    url: Scalars['String']} })
    bestSellers?: (ProductPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    filterableAttributes?: boolean | number
    edgeBands?: (EdgeBandsGenqlSelection & { __args: {productId: Scalars['ID'], query?: (Scalars['String'] | null), currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    edgeBand?: (EdgeBandGenqlSelection & { __args: {sku: Scalars['String']} })
    shareCode?: (ShareCodeGenqlSelection & { __args: {code: Scalars['String']} })
    contactSettings?: ContactSettingsGenqlSelection
    orderEditable?: (OrderEditableGenqlSelection & { __args: {email: Scalars['String'], id: Scalars['ID'], type: Scalars['String']} })
    isEmailAvailable?: { __args: {
    /** The new customer email */
    email: Scalars['String']} }
    addressSuggestions?: (AddressSuggestionResultGenqlSelection & { __args: {
    /** Part of address to search for */
    searchTerm: Scalars['String'], context?: (Scalars['String'] | null), countryCode: Scalars['String'], 
    /** Optional cartId to bundle validation requests for current cart */
    cartId?: (Scalars['ID'] | null)} })
    addressSuggestionDetail?: (AddressSuggestionDetailResultGenqlSelection & { __args: {context: Scalars['String'], countryCode: Scalars['String'], cartId?: (Scalars['ID'] | null)} })
    customer?: CustomerGenqlSelection
    customerOrder?: (CustomerOrderGenqlSelection & { __args: {
    /** The increment ID of the order */
    id: Scalars['ID']} })
    customerProject?: (CustomerProjectGenqlSelection & { __args: {id: Scalars['ID']} })
    furniture?: FurnitureGenqlSelection
    kiyohReviews?: (KiyohReviewPaginationGenqlSelection & { __args?: {currentPage?: (Scalars['Int'] | null), pageSize?: (Scalars['Int'] | null)} })
    cartQuote?: (CartQuoteGenqlSelection & { __args: {uuid: Scalars['String']} })
    /** Returns information about available shipping methods */
    shippingInformation?: ShippingInformationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface KiyohReviewPaginationGenqlSelection{
    /** List of items on the current page */
    items?: KiyohReviewGenqlSelection
    /** Number of total items selected by the query */
    total?: boolean | number
    /** Number of items returned per page */
    perPage?: boolean | number
    /** Current page of the cursor */
    currentPage?: boolean | number
    /** The last page (number of pages) */
    lastPage?: boolean | number
    /** Determines if cursor has more pages after the current page */
    hasMorePages?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MutationGenqlSelection{
    /** Add any type of product to the cart */
    addProductToCart?: (UpdateCartResultGenqlSelection & { __args: {input: UpdateCartInput} })
    /** Creates an empty shopping cart for a guest or logged in user */
    createEmptyCart?: boolean | number
    placeOrder?: (PlaceOrderOutputGenqlSelection & { __args: {input: PlaceOrderInput} })
    removeItemFromCart?: (UpdateCartResultGenqlSelection & { __args: {input: UpdateCartInput} })
    setBillingAddressOnCart?: (CartGenqlSelection & { __args: {input: BillingAddressInput} })
    setCustomerEmailOnCart?: (CartGenqlSelection & { __args: {cartId: Scalars['ID'], email: Scalars['String'], phone: Scalars['String'], company?: (Scalars['String'] | null), invoiceEmail?: (Scalars['String'] | null), taxvat?: (Scalars['String'] | null)} })
    setPaymentMethodOnCart?: (CartGenqlSelection & { __args: {input: SetPaymentMethodOnCartInput} })
    setShippingAddressOnCart?: (CartGenqlSelection & { __args: {input: ShippingAddressInput} })
    setShippingMethodOnCart?: (CartGenqlSelection & { __args: {input: SetShippingMethodOnCartInput} })
    /** Update the item in the cart */
    updateCartItem?: (UpdateCartResultGenqlSelection & { __args: {input: UpdateCartInput} })
    /** Update the orderdata of the item */
    updateOrderData?: (UpdateCartResultGenqlSelection & { __args: {input: UpdateOrderDataInput} })
    /** Update the sort order of items in the cart */
    updateCartSortOrder?: (CartGenqlSelection & { __args: {input: UpdateCartSortOrderInput} })
    removeCouponFromCart?: (CartGenqlSelection & { __args: {cartId: Scalars['ID']} })
    applyCouponToCart?: (CartGenqlSelection & { __args: {cartId: Scalars['ID'], couponCode: Scalars['String']} })
    clearCart?: (CartGenqlSelection & { __args: {cartId: Scalars['ID']} })
    /** Merges the source cart into the destination cart */
    mergeCarts?: (CartGenqlSelection & { __args: {sourceCartId: Scalars['ID'], destinationCartId: Scalars['ID']} })
    optimizeItem?: (CartGenqlSelection & { __args: {cartId: Scalars['ID'], itemId: Scalars['ID']} })
    toggleUseRestPieces?: (CartGenqlSelection & { __args: {cartId: Scalars['ID'], value: Scalars['Boolean']} })
    /** Creates a new CSV to import later */
    createImportCsv?: { __args: {cartId: Scalars['ID']} }
    /** Sends a alert when product is back in stock. */
    productAlert?: (ContactGenqlSelection & { __args: {email: Scalars['String'], id: Scalars['ID']} })
    createShareCode?: (ShareCodeGenqlSelection & { __args: {input: CreateShareCodeInput} })
    /** Send contact form and add FD ticket. */
    sendContact?: (ContactGenqlSelection & { __args: {input: ContactInput} })
    /** Sends a ticket to Freshdesk for the order edit form. */
    editOrderRequest?: (ContactGenqlSelection & { __args: {input: EditOrderRequestInput} })
    /** Sends a ticket to Freshdesk for the order edit form. */
    sendStylistContact?: (ContactGenqlSelection & { __args: {input: StylistContactInput} })
    /** Sends a email to the customer service for bloggers form */
    sendBloggersContact?: (ContactGenqlSelection & { __args: {input: BloggersContactInput} })
    /** Retrieve the customer token */
    generateCustomerToken?: (CustomerTokenGenqlSelection & { __args: {email: Scalars['String'], password: Scalars['String']} })
    /** Request an email with a reset password token for the registered customer identified by the specified email. */
    requestPasswordResetEmail?: { __args: {email: Scalars['String']} }
    /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using requestPasswordResetEmail. */
    resetPassword?: { __args: {id: Scalars['ID'], resetPasswordToken: Scalars['String'], newPassword: Scalars['String']} }
    /** Update the customer's email */
    updateCustomerEmail?: (CustomerGenqlSelection & { __args: {email: Scalars['String'], password: Scalars['String']} })
    /** Update the customer's personal information */
    updateCustomer?: (CustomerGenqlSelection & { __args: {input: UpdateCustomerInput} })
    /** Create customer account */
    createCustomer?: (CustomerGenqlSelection & { __args: {input: CreateCustomerInput} })
    /** Changes the password for the logged-in customer */
    changeCustomerPassword?: (CustomerGenqlSelection & { __args: {currentPassword: Scalars['String'], newPassword: Scalars['String']} })
    /** Create customer address */
    createCustomerAddress?: (CustomerGenqlSelection & { __args: {input: CustomerAddressInput} })
    /** Delete customer address */
    deleteCustomerAddress?: (CustomerGenqlSelection & { __args: {
    /** The ID of the address to delete */
    id: Scalars['ID']} })
    /** Update customer address */
    updateCustomerAddress?: (CustomerGenqlSelection & { __args: {
    /** The ID of the address to update */
    id: Scalars['ID'], input: CustomerAddressInput} })
    /** Validate the customer's VAT number */
    validateCustomerVat?: (CustomerVatGenqlSelection & { __args: {
    /** The ISO 3166-1 country code of the company */
    countryCode: Scalars['String'], 
    /** The customer tax number */
    vatNumber: Scalars['String'], 
    /** Optional cartId. In case of valid vatNumber, quote will be updated. */
    cartId?: (Scalars['String'] | null)} })
    removeProductFromWishlist?: (WishlistGenqlSelection & { __args: {productId: Scalars['ID']} })
    addProductToWishlist?: (WishlistGenqlSelection & { __args: {productId: Scalars['ID']} })
    /** Delete customer project */
    deleteCustomerProject?: (CustomerProjectGenqlSelection & { __args: {
    /** The ID of the project to delete */
    id: Scalars['ID']} })
    createCustomerProjectFromCart?: (CustomerProjectGenqlSelection & { __args: {cartId: Scalars['ID'], 
    /** The ID of the project to update. If not provided, a new project will be created. */
    projectId?: (Scalars['ID'] | null), name?: (Scalars['String'] | null)} })
    createCustomerProjectFromItem?: (CustomerProjectGenqlSelection & { __args: {cartItem: CartItemInput, 
    /** The ID of the project to update. If not provided, a new project will be created. */
    projectId?: (Scalars['ID'] | null), name?: (Scalars['String'] | null)} })
    addCustomerProjectToCart?: (CartGenqlSelection & { __args: {cartId: Scalars['ID'], projectId: Scalars['ID'], 
    /** The method to add the project to the cart. */
    method?: Scalars['String']} })
    applyForBusinessAccount?: (CustomerGenqlSelection & { __args: {input: ApplyForBusinessAccountInput} })
    updateCustomerProject?: (CustomerProjectGenqlSelection & { __args: {id: Scalars['ID'], input: CustomerProjectInput} })
    updateCustomerProjectItem?: (CustomerProjectItemGenqlSelection & { __args: {id: Scalars['ID'], input: CustomerProjectItemInput} })
    addCartQuoteToCart?: (CartGenqlSelection & { __args: {cartId: Scalars['ID'], cartQuote: Scalars['String'], mergeMethod: MergeMethod} })
    createSharableCart?: { __args: {input: CreateSharableCartInput} }
    __typename?: boolean | number
    __scalar?: boolean | number
}


    const AddressInterface_possibleTypes: string[] = ['BillingCartAddress','ShippingCartAddress','OrderAddress','CustomerAddress']
    export const isAddressInterface = (obj?: { __typename?: any } | null): obj is AddressInterface => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddressInterface"')
      return AddressInterface_possibleTypes.includes(obj.__typename)
    }
    


    const StoreInformation_possibleTypes: string[] = ['StoreInformation']
    export const isStoreInformation = (obj?: { __typename?: any } | null): obj is StoreInformation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStoreInformation"')
      return StoreInformation_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerService_possibleTypes: string[] = ['CustomerService']
    export const isCustomerService = (obj?: { __typename?: any } | null): obj is CustomerService => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerService"')
      return CustomerService_possibleTypes.includes(obj.__typename)
    }
    


    const Country_possibleTypes: string[] = ['Country']
    export const isCountry = (obj?: { __typename?: any } | null): obj is Country => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCountry"')
      return Country_possibleTypes.includes(obj.__typename)
    }
    


    const Region_possibleTypes: string[] = ['Region']
    export const isRegion = (obj?: { __typename?: any } | null): obj is Region => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRegion"')
      return Region_possibleTypes.includes(obj.__typename)
    }
    


    const FacebookInformation_possibleTypes: string[] = ['FacebookInformation']
    export const isFacebookInformation = (obj?: { __typename?: any } | null): obj is FacebookInformation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacebookInformation"')
      return FacebookInformation_possibleTypes.includes(obj.__typename)
    }
    


    const Website_possibleTypes: string[] = ['Website']
    export const isWebsite = (obj?: { __typename?: any } | null): obj is Website => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWebsite"')
      return Website_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentMethodInterface_possibleTypes: string[] = ['AvailablePaymentMethod','SelectedPaymentMethod']
    export const isPaymentMethodInterface = (obj?: { __typename?: any } | null): obj is PaymentMethodInterface => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentMethodInterface"')
      return PaymentMethodInterface_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingMethodInterface_possibleTypes: string[] = ['SelectedShippingMethod','AvailableShippingMethod']
    export const isShippingMethodInterface = (obj?: { __typename?: any } | null): obj is ShippingMethodInterface => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingMethodInterface"')
      return ShippingMethodInterface_possibleTypes.includes(obj.__typename)
    }
    


    const AvailablePaymentMethod_possibleTypes: string[] = ['AvailablePaymentMethod']
    export const isAvailablePaymentMethod = (obj?: { __typename?: any } | null): obj is AvailablePaymentMethod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAvailablePaymentMethod"')
      return AvailablePaymentMethod_possibleTypes.includes(obj.__typename)
    }
    


    const BillingCartAddress_possibleTypes: string[] = ['BillingCartAddress']
    export const isBillingCartAddress = (obj?: { __typename?: any } | null): obj is BillingCartAddress => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillingCartAddress"')
      return BillingCartAddress_possibleTypes.includes(obj.__typename)
    }
    


    const CartAddressCountry_possibleTypes: string[] = ['CartAddressCountry']
    export const isCartAddressCountry = (obj?: { __typename?: any } | null): obj is CartAddressCountry => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartAddressCountry"')
      return CartAddressCountry_possibleTypes.includes(obj.__typename)
    }
    


    const CartAddressRegion_possibleTypes: string[] = ['CartAddressRegion']
    export const isCartAddressRegion = (obj?: { __typename?: any } | null): obj is CartAddressRegion => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartAddressRegion"')
      return CartAddressRegion_possibleTypes.includes(obj.__typename)
    }
    


    const CartItem_possibleTypes: string[] = ['CartItem']
    export const isCartItem = (obj?: { __typename?: any } | null): obj is CartItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartItem"')
      return CartItem_possibleTypes.includes(obj.__typename)
    }
    


    const ProductPagination_possibleTypes: string[] = ['ProductPagination']
    export const isProductPagination = (obj?: { __typename?: any } | null): obj is ProductPagination => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductPagination"')
      return ProductPagination_possibleTypes.includes(obj.__typename)
    }
    


    const CartGroup_possibleTypes: string[] = ['CartGroup']
    export const isCartGroup = (obj?: { __typename?: any } | null): obj is CartGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartGroup"')
      return CartGroup_possibleTypes.includes(obj.__typename)
    }
    


    const CartItemTotals_possibleTypes: string[] = ['CartItemTotals']
    export const isCartItemTotals = (obj?: { __typename?: any } | null): obj is CartItemTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartItemTotals"')
      return CartItemTotals_possibleTypes.includes(obj.__typename)
    }
    


    const Cart_possibleTypes: string[] = ['Cart']
    export const isCart = (obj?: { __typename?: any } | null): obj is Cart => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCart"')
      return Cart_possibleTypes.includes(obj.__typename)
    }
    


    const CartTotals_possibleTypes: string[] = ['CartTotals']
    export const isCartTotals = (obj?: { __typename?: any } | null): obj is CartTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartTotals"')
      return CartTotals_possibleTypes.includes(obj.__typename)
    }
    


    const OrderItemTotals_possibleTypes: string[] = ['OrderItemTotals']
    export const isOrderItemTotals = (obj?: { __typename?: any } | null): obj is OrderItemTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderItemTotals"')
      return OrderItemTotals_possibleTypes.includes(obj.__typename)
    }
    


    const PriceLabel_possibleTypes: string[] = ['PriceLabel']
    export const isPriceLabel = (obj?: { __typename?: any } | null): obj is PriceLabel => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPriceLabel"')
      return PriceLabel_possibleTypes.includes(obj.__typename)
    }
    


    const Money_possibleTypes: string[] = ['Money']
    export const isMoney = (obj?: { __typename?: any } | null): obj is Money => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMoney"')
      return Money_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentOption_possibleTypes: string[] = ['PaymentOption']
    export const isPaymentOption = (obj?: { __typename?: any } | null): obj is PaymentOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentOption"')
      return PaymentOption_possibleTypes.includes(obj.__typename)
    }
    


    const PlaceOrderOutput_possibleTypes: string[] = ['PlaceOrderOutput']
    export const isPlaceOrderOutput = (obj?: { __typename?: any } | null): obj is PlaceOrderOutput => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPlaceOrderOutput"')
      return PlaceOrderOutput_possibleTypes.includes(obj.__typename)
    }
    


    const SelectedPaymentMethod_possibleTypes: string[] = ['SelectedPaymentMethod']
    export const isSelectedPaymentMethod = (obj?: { __typename?: any } | null): obj is SelectedPaymentMethod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSelectedPaymentMethod"')
      return SelectedPaymentMethod_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingCartAddress_possibleTypes: string[] = ['ShippingCartAddress']
    export const isShippingCartAddress = (obj?: { __typename?: any } | null): obj is ShippingCartAddress => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingCartAddress"')
      return ShippingCartAddress_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingCarrier_possibleTypes: string[] = ['ShippingCarrier']
    export const isShippingCarrier = (obj?: { __typename?: any } | null): obj is ShippingCarrier => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingCarrier"')
      return ShippingCarrier_possibleTypes.includes(obj.__typename)
    }
    


    const SelectedShippingCarrier_possibleTypes: string[] = ['SelectedShippingCarrier']
    export const isSelectedShippingCarrier = (obj?: { __typename?: any } | null): obj is SelectedShippingCarrier => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSelectedShippingCarrier"')
      return SelectedShippingCarrier_possibleTypes.includes(obj.__typename)
    }
    


    const SelectedShippingMethod_possibleTypes: string[] = ['SelectedShippingMethod']
    export const isSelectedShippingMethod = (obj?: { __typename?: any } | null): obj is SelectedShippingMethod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSelectedShippingMethod"')
      return SelectedShippingMethod_possibleTypes.includes(obj.__typename)
    }
    


    const AvailableShippingMethod_possibleTypes: string[] = ['AvailableShippingMethod']
    export const isAvailableShippingMethod = (obj?: { __typename?: any } | null): obj is AvailableShippingMethod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAvailableShippingMethod"')
      return AvailableShippingMethod_possibleTypes.includes(obj.__typename)
    }
    


    const UpdateCartResult_possibleTypes: string[] = ['UpdateCartResult']
    export const isUpdateCartResult = (obj?: { __typename?: any } | null): obj is UpdateCartResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUpdateCartResult"')
      return UpdateCartResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreditMemo_possibleTypes: string[] = ['CreditMemo']
    export const isCreditMemo = (obj?: { __typename?: any } | null): obj is CreditMemo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreditMemo"')
      return CreditMemo_possibleTypes.includes(obj.__typename)
    }
    


    const Shipment_possibleTypes: string[] = ['Shipment']
    export const isShipment = (obj?: { __typename?: any } | null): obj is Shipment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShipment"')
      return Shipment_possibleTypes.includes(obj.__typename)
    }
    


    const ShipmentTracking_possibleTypes: string[] = ['ShipmentTracking']
    export const isShipmentTracking = (obj?: { __typename?: any } | null): obj is ShipmentTracking => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShipmentTracking"')
      return ShipmentTracking_possibleTypes.includes(obj.__typename)
    }
    


    const Invoice_possibleTypes: string[] = ['Invoice']
    export const isInvoice = (obj?: { __typename?: any } | null): obj is Invoice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoice"')
      return Invoice_possibleTypes.includes(obj.__typename)
    }
    


    const InvoiceTotal_possibleTypes: string[] = ['InvoiceTotal']
    export const isInvoiceTotal = (obj?: { __typename?: any } | null): obj is InvoiceTotal => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoiceTotal"')
      return InvoiceTotal_possibleTypes.includes(obj.__typename)
    }
    


    const OrderAddress_possibleTypes: string[] = ['OrderAddress']
    export const isOrderAddress = (obj?: { __typename?: any } | null): obj is OrderAddress => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderAddress"')
      return OrderAddress_possibleTypes.includes(obj.__typename)
    }
    


    const OrderTotals_possibleTypes: string[] = ['OrderTotals']
    export const isOrderTotals = (obj?: { __typename?: any } | null): obj is OrderTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderTotals"')
      return OrderTotals_possibleTypes.includes(obj.__typename)
    }
    


    const OrderItem_possibleTypes: string[] = ['OrderItem']
    export const isOrderItem = (obj?: { __typename?: any } | null): obj is OrderItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderItem"')
      return OrderItem_possibleTypes.includes(obj.__typename)
    }
    


    const OrderSuccess_possibleTypes: string[] = ['OrderSuccess']
    export const isOrderSuccess = (obj?: { __typename?: any } | null): obj is OrderSuccess => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderSuccess"')
      return OrderSuccess_possibleTypes.includes(obj.__typename)
    }
    


    const AppliedFinish_possibleTypes: string[] = ['AppliedFinish']
    export const isAppliedFinish = (obj?: { __typename?: any } | null): obj is AppliedFinish => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAppliedFinish"')
      return AppliedFinish_possibleTypes.includes(obj.__typename)
    }
    


    const Dimensions_possibleTypes: string[] = ['Dimensions']
    export const isDimensions = (obj?: { __typename?: any } | null): obj is Dimensions => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDimensions"')
      return Dimensions_possibleTypes.includes(obj.__typename)
    }
    


    const CabinetSpecs_possibleTypes: string[] = ['CabinetSpecs']
    export const isCabinetSpecs = (obj?: { __typename?: any } | null): obj is CabinetSpecs => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCabinetSpecs"')
      return CabinetSpecs_possibleTypes.includes(obj.__typename)
    }
    


    const CabinetSpecsData_possibleTypes: string[] = ['CabinetSpecsData']
    export const isCabinetSpecsData = (obj?: { __typename?: any } | null): obj is CabinetSpecsData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCabinetSpecsData"')
      return CabinetSpecsData_possibleTypes.includes(obj.__typename)
    }
    


    const WoodSpecification_possibleTypes: string[] = ['WoodSpecification']
    export const isWoodSpecification = (obj?: { __typename?: any } | null): obj is WoodSpecification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWoodSpecification"')
      return WoodSpecification_possibleTypes.includes(obj.__typename)
    }
    


    const WoodCompleteSpecification_possibleTypes: string[] = ['WoodCompleteSpecification']
    export const isWoodCompleteSpecification = (obj?: { __typename?: any } | null): obj is WoodCompleteSpecification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWoodCompleteSpecification"')
      return WoodCompleteSpecification_possibleTypes.includes(obj.__typename)
    }
    


    const WoodCompleteRestSpecification_possibleTypes: string[] = ['WoodCompleteRestSpecification']
    export const isWoodCompleteRestSpecification = (obj?: { __typename?: any } | null): obj is WoodCompleteRestSpecification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWoodCompleteRestSpecification"')
      return WoodCompleteRestSpecification_possibleTypes.includes(obj.__typename)
    }
    


    const PlasticSpecification_possibleTypes: string[] = ['PlasticSpecification']
    export const isPlasticSpecification = (obj?: { __typename?: any } | null): obj is PlasticSpecification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPlasticSpecification"')
      return PlasticSpecification_possibleTypes.includes(obj.__typename)
    }
    


    const SheetFurnitureSpecification_possibleTypes: string[] = ['SheetFurnitureSpecification']
    export const isSheetFurnitureSpecification = (obj?: { __typename?: any } | null): obj is SheetFurnitureSpecification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSheetFurnitureSpecification"')
      return SheetFurnitureSpecification_possibleTypes.includes(obj.__typename)
    }
    


    const TableSpecification_possibleTypes: string[] = ['TableSpecification']
    export const isTableSpecification = (obj?: { __typename?: any } | null): obj is TableSpecification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTableSpecification"')
      return TableSpecification_possibleTypes.includes(obj.__typename)
    }
    


    const FeeSpecification_possibleTypes: string[] = ['FeeSpecification']
    export const isFeeSpecification = (obj?: { __typename?: any } | null): obj is FeeSpecification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFeeSpecification"')
      return FeeSpecification_possibleTypes.includes(obj.__typename)
    }
    


    const OptimizationResult_possibleTypes: string[] = ['OptimizationResult']
    export const isOptimizationResult = (obj?: { __typename?: any } | null): obj is OptimizationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOptimizationResult"')
      return OptimizationResult_possibleTypes.includes(obj.__typename)
    }
    


    const OptimizationItem_possibleTypes: string[] = ['OptimizationItem']
    export const isOptimizationItem = (obj?: { __typename?: any } | null): obj is OptimizationItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOptimizationItem"')
      return OptimizationItem_possibleTypes.includes(obj.__typename)
    }
    


    const OptimizationDimensions_possibleTypes: string[] = ['OptimizationDimensions']
    export const isOptimizationDimensions = (obj?: { __typename?: any } | null): obj is OptimizationDimensions => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOptimizationDimensions"')
      return OptimizationDimensions_possibleTypes.includes(obj.__typename)
    }
    


    const ItemSpecifications_possibleTypes: string[] = ['WoodSpecification','WoodCompleteSpecification','WoodCompleteRestSpecification','PlasticSpecification','TableSpecification','FeeSpecification','SheetFurnitureSpecification']
    export const isItemSpecifications = (obj?: { __typename?: any } | null): obj is ItemSpecifications => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemSpecifications"')
      return ItemSpecifications_possibleTypes.includes(obj.__typename)
    }
    


    const Products_possibleTypes: string[] = ['Products']
    export const isProducts = (obj?: { __typename?: any } | null): obj is Products => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProducts"')
      return Products_possibleTypes.includes(obj.__typename)
    }
    


    const Product_possibleTypes: string[] = ['Product']
    export const isProduct = (obj?: { __typename?: any } | null): obj is Product => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProduct"')
      return Product_possibleTypes.includes(obj.__typename)
    }
    


    const ProductAttribute_possibleTypes: string[] = ['ProductAttribute']
    export const isProductAttribute = (obj?: { __typename?: any } | null): obj is ProductAttribute => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductAttribute"')
      return ProductAttribute_possibleTypes.includes(obj.__typename)
    }
    


    const Category_possibleTypes: string[] = ['Category']
    export const isCategory = (obj?: { __typename?: any } | null): obj is Category => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategory"')
      return Category_possibleTypes.includes(obj.__typename)
    }
    


    const UrlResolverResult_possibleTypes: string[] = ['UrlResolverResult']
    export const isUrlResolverResult = (obj?: { __typename?: any } | null): obj is UrlResolverResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUrlResolverResult"')
      return UrlResolverResult_possibleTypes.includes(obj.__typename)
    }
    


    const AggregationOption_possibleTypes: string[] = ['AggregationOption']
    export const isAggregationOption = (obj?: { __typename?: any } | null): obj is AggregationOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAggregationOption"')
      return AggregationOption_possibleTypes.includes(obj.__typename)
    }
    


    const Aggregation_possibleTypes: string[] = ['Aggregation']
    export const isAggregation = (obj?: { __typename?: any } | null): obj is Aggregation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAggregation"')
      return Aggregation_possibleTypes.includes(obj.__typename)
    }
    


    const PageInfo_possibleTypes: string[] = ['PageInfo']
    export const isPageInfo = (obj?: { __typename?: any } | null): obj is PageInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageInfo"')
      return PageInfo_possibleTypes.includes(obj.__typename)
    }
    


    const SortFields_possibleTypes: string[] = ['SortFields']
    export const isSortFields = (obj?: { __typename?: any } | null): obj is SortFields => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSortFields"')
      return SortFields_possibleTypes.includes(obj.__typename)
    }
    


    const SortField_possibleTypes: string[] = ['SortField']
    export const isSortField = (obj?: { __typename?: any } | null): obj is SortField => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSortField"')
      return SortField_possibleTypes.includes(obj.__typename)
    }
    


    const PanelType_possibleTypes: string[] = ['PanelType']
    export const isPanelType = (obj?: { __typename?: any } | null): obj is PanelType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPanelType"')
      return PanelType_possibleTypes.includes(obj.__typename)
    }
    


    const SheetFurnitureType_possibleTypes: string[] = ['SheetFurnitureType']
    export const isSheetFurnitureType = (obj?: { __typename?: any } | null): obj is SheetFurnitureType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSheetFurnitureType"')
      return SheetFurnitureType_possibleTypes.includes(obj.__typename)
    }
    


    const TableType_possibleTypes: string[] = ['TableType']
    export const isTableType = (obj?: { __typename?: any } | null): obj is TableType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTableType"')
      return TableType_possibleTypes.includes(obj.__typename)
    }
    


    const AccessoryType_possibleTypes: string[] = ['AccessoryType']
    export const isAccessoryType = (obj?: { __typename?: any } | null): obj is AccessoryType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccessoryType"')
      return AccessoryType_possibleTypes.includes(obj.__typename)
    }
    


    const Shape_possibleTypes: string[] = ['Shape']
    export const isShape = (obj?: { __typename?: any } | null): obj is Shape => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShape"')
      return Shape_possibleTypes.includes(obj.__typename)
    }
    


    const Finish_possibleTypes: string[] = ['Finish']
    export const isFinish = (obj?: { __typename?: any } | null): obj is Finish => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinish"')
      return Finish_possibleTypes.includes(obj.__typename)
    }
    


    const ImageGalleryType_possibleTypes: string[] = ['ImageGalleryType']
    export const isImageGalleryType = (obj?: { __typename?: any } | null): obj is ImageGalleryType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isImageGalleryType"')
      return ImageGalleryType_possibleTypes.includes(obj.__typename)
    }
    


    const VideosType_possibleTypes: string[] = ['VideosType']
    export const isVideosType = (obj?: { __typename?: any } | null): obj is VideosType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVideosType"')
      return VideosType_possibleTypes.includes(obj.__typename)
    }
    


    const FurnitureToolStepsType_possibleTypes: string[] = ['FurnitureToolStepsType']
    export const isFurnitureToolStepsType = (obj?: { __typename?: any } | null): obj is FurnitureToolStepsType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurnitureToolStepsType"')
      return FurnitureToolStepsType_possibleTypes.includes(obj.__typename)
    }
    


    const FinishOption_possibleTypes: string[] = ['FinishOption']
    export const isFinishOption = (obj?: { __typename?: any } | null): obj is FinishOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinishOption"')
      return FinishOption_possibleTypes.includes(obj.__typename)
    }
    


    const FinishOptionData_possibleTypes: string[] = ['FinishOptionData']
    export const isFinishOptionData = (obj?: { __typename?: any } | null): obj is FinishOptionData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinishOptionData"')
      return FinishOptionData_possibleTypes.includes(obj.__typename)
    }
    


    const FinishSide_possibleTypes: string[] = ['FinishSide']
    export const isFinishSide = (obj?: { __typename?: any } | null): obj is FinishSide => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinishSide"')
      return FinishSide_possibleTypes.includes(obj.__typename)
    }
    


    const ProductType_possibleTypes: string[] = ['PanelType','SheetFurnitureType','TableType','AccessoryType']
    export const isProductType = (obj?: { __typename?: any } | null): obj is ProductType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductType"')
      return ProductType_possibleTypes.includes(obj.__typename)
    }
    


    const ProductsPerPage_possibleTypes: string[] = ['ProductsPerPage']
    export const isProductsPerPage = (obj?: { __typename?: any } | null): obj is ProductsPerPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProductsPerPage"')
      return ProductsPerPage_possibleTypes.includes(obj.__typename)
    }
    


    const GridPerPage_possibleTypes: string[] = ['GridPerPage']
    export const isGridPerPage = (obj?: { __typename?: any } | null): obj is GridPerPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGridPerPage"')
      return GridPerPage_possibleTypes.includes(obj.__typename)
    }
    


    const HrefLang_possibleTypes: string[] = ['HrefLang']
    export const isHrefLang = (obj?: { __typename?: any } | null): obj is HrefLang => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHrefLang"')
      return HrefLang_possibleTypes.includes(obj.__typename)
    }
    


    const Asset_possibleTypes: string[] = ['Asset']
    export const isAsset = (obj?: { __typename?: any } | null): obj is Asset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAsset"')
      return Asset_possibleTypes.includes(obj.__typename)
    }
    


    const SpecificationSheet_possibleTypes: string[] = ['SpecificationSheet']
    export const isSpecificationSheet = (obj?: { __typename?: any } | null): obj is SpecificationSheet => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSpecificationSheet"')
      return SpecificationSheet_possibleTypes.includes(obj.__typename)
    }
    


    const EdgeBand_possibleTypes: string[] = ['EdgeBand']
    export const isEdgeBand = (obj?: { __typename?: any } | null): obj is EdgeBand => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEdgeBand"')
      return EdgeBand_possibleTypes.includes(obj.__typename)
    }
    


    const EdgeBands_possibleTypes: string[] = ['EdgeBands']
    export const isEdgeBands = (obj?: { __typename?: any } | null): obj is EdgeBands => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEdgeBands"')
      return EdgeBands_possibleTypes.includes(obj.__typename)
    }
    


    const EdgeBandPagination_possibleTypes: string[] = ['EdgeBandPagination']
    export const isEdgeBandPagination = (obj?: { __typename?: any } | null): obj is EdgeBandPagination => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEdgeBandPagination"')
      return EdgeBandPagination_possibleTypes.includes(obj.__typename)
    }
    


    const ShareCode_possibleTypes: string[] = ['ShareCode']
    export const isShareCode = (obj?: { __typename?: any } | null): obj is ShareCode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShareCode"')
      return ShareCode_possibleTypes.includes(obj.__typename)
    }
    


    const Contact_possibleTypes: string[] = ['Contact']
    export const isContact = (obj?: { __typename?: any } | null): obj is Contact => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContact"')
      return Contact_possibleTypes.includes(obj.__typename)
    }
    


    const ContactSettings_possibleTypes: string[] = ['ContactSettings']
    export const isContactSettings = (obj?: { __typename?: any } | null): obj is ContactSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContactSettings"')
      return ContactSettings_possibleTypes.includes(obj.__typename)
    }
    


    const ContactSubject_possibleTypes: string[] = ['ContactSubject']
    export const isContactSubject = (obj?: { __typename?: any } | null): obj is ContactSubject => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContactSubject"')
      return ContactSubject_possibleTypes.includes(obj.__typename)
    }
    


    const OrderEditable_possibleTypes: string[] = ['OrderEditable']
    export const isOrderEditable = (obj?: { __typename?: any } | null): obj is OrderEditable => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrderEditable"')
      return OrderEditable_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerToken_possibleTypes: string[] = ['CustomerToken']
    export const isCustomerToken = (obj?: { __typename?: any } | null): obj is CustomerToken => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerToken"')
      return CustomerToken_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerAddress_possibleTypes: string[] = ['CustomerAddress']
    export const isCustomerAddress = (obj?: { __typename?: any } | null): obj is CustomerAddress => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerAddress"')
      return CustomerAddress_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerOrder_possibleTypes: string[] = ['CustomerOrder']
    export const isCustomerOrder = (obj?: { __typename?: any } | null): obj is CustomerOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerOrder"')
      return CustomerOrder_possibleTypes.includes(obj.__typename)
    }
    


    const Customer_possibleTypes: string[] = ['Customer']
    export const isCustomer = (obj?: { __typename?: any } | null): obj is Customer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomer"')
      return Customer_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerProjectPagination_possibleTypes: string[] = ['CustomerProjectPagination']
    export const isCustomerProjectPagination = (obj?: { __typename?: any } | null): obj is CustomerProjectPagination => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerProjectPagination"')
      return CustomerProjectPagination_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerProjectItemPagination_possibleTypes: string[] = ['CustomerProjectItemPagination']
    export const isCustomerProjectItemPagination = (obj?: { __typename?: any } | null): obj is CustomerProjectItemPagination => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerProjectItemPagination"')
      return CustomerProjectItemPagination_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerOrderPagination_possibleTypes: string[] = ['CustomerOrderPagination']
    export const isCustomerOrderPagination = (obj?: { __typename?: any } | null): obj is CustomerOrderPagination => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerOrderPagination"')
      return CustomerOrderPagination_possibleTypes.includes(obj.__typename)
    }
    


    const Wishlist_possibleTypes: string[] = ['Wishlist']
    export const isWishlist = (obj?: { __typename?: any } | null): obj is Wishlist => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWishlist"')
      return Wishlist_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerVat_possibleTypes: string[] = ['CustomerVat']
    export const isCustomerVat = (obj?: { __typename?: any } | null): obj is CustomerVat => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerVat"')
      return CustomerVat_possibleTypes.includes(obj.__typename)
    }
    


    const AddressSuggestionResult_possibleTypes: string[] = ['AddressSuggestionResult']
    export const isAddressSuggestionResult = (obj?: { __typename?: any } | null): obj is AddressSuggestionResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddressSuggestionResult"')
      return AddressSuggestionResult_possibleTypes.includes(obj.__typename)
    }
    


    const AddressSuggestionDetailResult_possibleTypes: string[] = ['AddressSuggestionDetailResult']
    export const isAddressSuggestionDetailResult = (obj?: { __typename?: any } | null): obj is AddressSuggestionDetailResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddressSuggestionDetailResult"')
      return AddressSuggestionDetailResult_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerProject_possibleTypes: string[] = ['CustomerProject']
    export const isCustomerProject = (obj?: { __typename?: any } | null): obj is CustomerProject => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerProject"')
      return CustomerProject_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerProjectItem_possibleTypes: string[] = ['CustomerProjectItem']
    export const isCustomerProjectItem = (obj?: { __typename?: any } | null): obj is CustomerProjectItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerProjectItem"')
      return CustomerProjectItem_possibleTypes.includes(obj.__typename)
    }
    


    const Tracking_possibleTypes: string[] = ['Tracking']
    export const isTracking = (obj?: { __typename?: any } | null): obj is Tracking => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTracking"')
      return Tracking_possibleTypes.includes(obj.__typename)
    }
    


    const Furniture_possibleTypes: string[] = ['Furniture']
    export const isFurniture = (obj?: { __typename?: any } | null): obj is Furniture => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurniture"')
      return Furniture_possibleTypes.includes(obj.__typename)
    }
    


    const FurnitureConstraints_possibleTypes: string[] = ['FurnitureConstraints']
    export const isFurnitureConstraints = (obj?: { __typename?: any } | null): obj is FurnitureConstraints => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurnitureConstraints"')
      return FurnitureConstraints_possibleTypes.includes(obj.__typename)
    }
    


    const FurnitureConstraint_possibleTypes: string[] = ['FurnitureConstraint']
    export const isFurnitureConstraint = (obj?: { __typename?: any } | null): obj is FurnitureConstraint => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurnitureConstraint"')
      return FurnitureConstraint_possibleTypes.includes(obj.__typename)
    }
    


    const FurniturePrice_possibleTypes: string[] = ['FurniturePrice']
    export const isFurniturePrice = (obj?: { __typename?: any } | null): obj is FurniturePrice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurniturePrice"')
      return FurniturePrice_possibleTypes.includes(obj.__typename)
    }
    


    const FurnitureMaterial_possibleTypes: string[] = ['FurnitureMaterial']
    export const isFurnitureMaterial = (obj?: { __typename?: any } | null): obj is FurnitureMaterial => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurnitureMaterial"')
      return FurnitureMaterial_possibleTypes.includes(obj.__typename)
    }
    


    const FurnitureThickness_possibleTypes: string[] = ['FurnitureThickness']
    export const isFurnitureThickness = (obj?: { __typename?: any } | null): obj is FurnitureThickness => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurnitureThickness"')
      return FurnitureThickness_possibleTypes.includes(obj.__typename)
    }
    


    const FurnitureThicknessParts_possibleTypes: string[] = ['FurnitureThicknessParts']
    export const isFurnitureThicknessParts = (obj?: { __typename?: any } | null): obj is FurnitureThicknessParts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurnitureThicknessParts"')
      return FurnitureThicknessParts_possibleTypes.includes(obj.__typename)
    }
    


    const FurnitureThicknessPartData_possibleTypes: string[] = ['FurnitureThicknessPartData']
    export const isFurnitureThicknessPartData = (obj?: { __typename?: any } | null): obj is FurnitureThicknessPartData => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFurnitureThicknessPartData"')
      return FurnitureThicknessPartData_possibleTypes.includes(obj.__typename)
    }
    


    const KiyohReview_possibleTypes: string[] = ['KiyohReview']
    export const isKiyohReview = (obj?: { __typename?: any } | null): obj is KiyohReview => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isKiyohReview"')
      return KiyohReview_possibleTypes.includes(obj.__typename)
    }
    


    const KiyohInformation_possibleTypes: string[] = ['KiyohInformation']
    export const isKiyohInformation = (obj?: { __typename?: any } | null): obj is KiyohInformation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isKiyohInformation"')
      return KiyohInformation_possibleTypes.includes(obj.__typename)
    }
    


    const CartQuote_possibleTypes: string[] = ['CartQuote']
    export const isCartQuote = (obj?: { __typename?: any } | null): obj is CartQuote => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartQuote"')
      return CartQuote_possibleTypes.includes(obj.__typename)
    }
    


    const CartQuoteProduct_possibleTypes: string[] = ['CartItem','OrderItem']
    export const isCartQuoteProduct = (obj?: { __typename?: any } | null): obj is CartQuoteProduct => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCartQuoteProduct"')
      return CartQuoteProduct_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingInformation_possibleTypes: string[] = ['ShippingInformation']
    export const isShippingInformation = (obj?: { __typename?: any } | null): obj is ShippingInformation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingInformation"')
      return ShippingInformation_possibleTypes.includes(obj.__typename)
    }
    


    const Query_possibleTypes: string[] = ['Query']
    export const isQuery = (obj?: { __typename?: any } | null): obj is Query => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuery"')
      return Query_possibleTypes.includes(obj.__typename)
    }
    


    const KiyohReviewPagination_possibleTypes: string[] = ['KiyohReviewPagination']
    export const isKiyohReviewPagination = (obj?: { __typename?: any } | null): obj is KiyohReviewPagination => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isKiyohReviewPagination"')
      return KiyohReviewPagination_possibleTypes.includes(obj.__typename)
    }
    


    const Mutation_possibleTypes: string[] = ['Mutation']
    export const isMutation = (obj?: { __typename?: any } | null): obj is Mutation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMutation"')
      return Mutation_possibleTypes.includes(obj.__typename)
    }
    

export const enumCurrencyEnum = {
   AFN: 'AFN' as const,
   ALL: 'ALL' as const,
   DZD: 'DZD' as const,
   USD: 'USD' as const,
   AOA: 'AOA' as const,
   ARS: 'ARS' as const,
   AMD: 'AMD' as const,
   AWG: 'AWG' as const,
   AUD: 'AUD' as const,
   AZN: 'AZN' as const,
   AZM: 'AZM' as const,
   BSD: 'BSD' as const,
   BHD: 'BHD' as const,
   BBD: 'BBD' as const,
   BZD: 'BZD' as const,
   BDT: 'BDT' as const,
   BMD: 'BMD' as const,
   BTN: 'BTN' as const,
   BUK: 'BUK' as const,
   BOB: 'BOB' as const,
   BAM: 'BAM' as const,
   BWP: 'BWP' as const,
   BRL: 'BRL' as const,
   GBP: 'GBP' as const,
   BND: 'BND' as const,
   BGN: 'BGN' as const,
   BIF: 'BIF' as const,
   XOF: 'XOF' as const,
   XPF: 'XPF' as const,
   KHR: 'KHR' as const,
   CAD: 'CAD' as const,
   KYD: 'KYD' as const,
   CLP: 'CLP' as const,
   CNY: 'CNY' as const,
   COP: 'COP' as const,
   KMF: 'KMF' as const,
   CDF: 'CDF' as const,
   CRC: 'CRC' as const,
   CUP: 'CUP' as const,
   DKK: 'DKK' as const,
   DJF: 'DJF' as const,
   DOP: 'DOP' as const,
   EGP: 'EGP' as const,
   GQE: 'GQE' as const,
   ERN: 'ERN' as const,
   EEK: 'EEK' as const,
   ETB: 'ETB' as const,
   EUR: 'EUR' as const,
   FKP: 'FKP' as const,
   FJD: 'FJD' as const,
   PHP: 'PHP' as const,
   GMD: 'GMD' as const,
   GEK: 'GEK' as const,
   GEL: 'GEL' as const,
   GHS: 'GHS' as const,
   GIP: 'GIP' as const,
   GTQ: 'GTQ' as const,
   GNF: 'GNF' as const,
   GYD: 'GYD' as const,
   HTG: 'HTG' as const,
   HNL: 'HNL' as const,
   HUF: 'HUF' as const,
   HKD: 'HKD' as const,
   ISK: 'ISK' as const,
   INR: 'INR' as const,
   IDR: 'IDR' as const,
   IQD: 'IQD' as const,
   IRR: 'IRR' as const,
   ILS: 'ILS' as const,
   JMD: 'JMD' as const,
   JPY: 'JPY' as const,
   YER: 'YER' as const,
   JOD: 'JOD' as const,
   CVE: 'CVE' as const,
   KZT: 'KZT' as const,
   KES: 'KES' as const,
   KGS: 'KGS' as const,
   KWD: 'KWD' as const,
   HRK: 'HRK' as const,
   LAK: 'LAK' as const,
   LSL: 'LSL' as const,
   LVL: 'LVL' as const,
   LBP: 'LBP' as const,
   LRD: 'LRD' as const,
   LYD: 'LYD' as const,
   LTL: 'LTL' as const,
   MOP: 'MOP' as const,
   MKD: 'MKD' as const,
   MGA: 'MGA' as const,
   MWK: 'MWK' as const,
   MVR: 'MVR' as const,
   MYR: 'MYR' as const,
   MAD: 'MAD' as const,
   MRO: 'MRO' as const,
   MUR: 'MUR' as const,
   MXN: 'MXN' as const,
   MDL: 'MDL' as const,
   MNT: 'MNT' as const,
   MZN: 'MZN' as const,
   MMK: 'MMK' as const,
   NAD: 'NAD' as const,
   ANG: 'ANG' as const,
   NPR: 'NPR' as const,
   NIC: 'NIC' as const,
   NZD: 'NZD' as const,
   TWD: 'TWD' as const,
   NGN: 'NGN' as const,
   KPW: 'KPW' as const,
   NOK: 'NOK' as const,
   UGX: 'UGX' as const,
   UAH: 'UAH' as const,
   UZS: 'UZS' as const,
   OMR: 'OMR' as const,
   XCD: 'XCD' as const,
   ROL: 'ROL' as const,
   PKR: 'PKR' as const,
   PAB: 'PAB' as const,
   PGK: 'PGK' as const,
   PYG: 'PYG' as const,
   PEN: 'PEN' as const,
   PLN: 'PLN' as const,
   QAR: 'QAR' as const,
   RHD: 'RHD' as const,
   RON: 'RON' as const,
   RUB: 'RUB' as const,
   RWF: 'RWF' as const,
   SBD: 'SBD' as const,
   SVC: 'SVC' as const,
   WST: 'WST' as const,
   STD: 'STD' as const,
   SAR: 'SAR' as const,
   RSD: 'RSD' as const,
   SCR: 'SCR' as const,
   SLL: 'SLL' as const,
   SGD: 'SGD' as const,
   SHP: 'SHP' as const,
   SKK: 'SKK' as const,
   SDG: 'SDG' as const,
   SOS: 'SOS' as const,
   LKR: 'LKR' as const,
   SRD: 'SRD' as const,
   SZL: 'SZL' as const,
   SYP: 'SYP' as const,
   TJS: 'TJS' as const,
   TZS: 'TZS' as const,
   THB: 'THB' as const,
   TOP: 'TOP' as const,
   TTD: 'TTD' as const,
   CZK: 'CZK' as const,
   TND: 'TND' as const,
   TMM: 'TMM' as const,
   TRY: 'TRY' as const,
   TRL: 'TRL' as const,
   UYU: 'UYU' as const,
   VUV: 'VUV' as const,
   VEF: 'VEF' as const,
   VEB: 'VEB' as const,
   AED: 'AED' as const,
   VND: 'VND' as const,
   CHE: 'CHE' as const,
   CHW: 'CHW' as const,
   BYR: 'BYR' as const,
   ZMK: 'ZMK' as const,
   ZWD: 'ZWD' as const,
   ZAR: 'ZAR' as const,
   KRW: 'KRW' as const,
   SEK: 'SEK' as const,
   CHF: 'CHF' as const
}

export const enumPaymentChargeEnum = {
   PERCENTAGE: 'PERCENTAGE' as const,
   FIXED_VALUE: 'FIXED_VALUE' as const
}

export const enumCartItemTypeEnum = {
   DEFAULT: 'DEFAULT' as const,
   CHILD: 'CHILD' as const
}

export const enumUrlType = {
   CATEGORY: 'CATEGORY' as const,
   PRODUCT: 'PRODUCT' as const,
   DIY_OVERVIEW: 'DIY_OVERVIEW' as const,
   DIY_DETAIL: 'DIY_DETAIL' as const,
   DIY_CATEGORY: 'DIY_CATEGORY' as const,
   DIY_CATEGORY_LANDING: 'DIY_CATEGORY_LANDING' as const,
   CUSTOMER_SERVICE_OVERVIEW: 'CUSTOMER_SERVICE_OVERVIEW' as const,
   CUSTOMER_SERVICE_VIEW: 'CUSTOMER_SERVICE_VIEW' as const,
   CUSTOMER_SERVICE_DETAIL: 'CUSTOMER_SERVICE_DETAIL' as const,
   CUSTOMER_REVIEWS: 'CUSTOMER_REVIEWS' as const,
   VIDEOS_OVERVIEW: 'VIDEOS_OVERVIEW' as const,
   VIDEOS_DETAIL: 'VIDEOS_DETAIL' as const,
   BUSINESS_OVERVIEW: 'BUSINESS_OVERVIEW' as const,
   STYLIST_DETAIL: 'STYLIST_DETAIL' as const,
   STYLIST_OVERVIEW: 'STYLIST_OVERVIEW' as const,
   LANDING: 'LANDING' as const,
   LANDING_OVERVIEW: 'LANDING_OVERVIEW' as const,
   TIPS: 'TIPS' as const,
   TIPS_OVERVIEW: 'TIPS_OVERVIEW' as const,
   POST: 'POST' as const,
   BRAND: 'BRAND' as const,
   BRAND_OVERVIEW: 'BRAND_OVERVIEW' as const,
   KNOWLEDGE: 'KNOWLEDGE' as const,
   KNOWLEDGE_OVERVIEW: 'KNOWLEDGE_OVERVIEW' as const,
   DIY_HOME: 'DIY_HOME' as const,
   POST_OVERVIEW: 'POST_OVERVIEW' as const,
   BLOGGERS: 'BLOGGERS' as const,
   DIY_SEND: 'DIY_SEND' as const,
   FAQ_ITEM: 'FAQ_ITEM' as const
}

export const enumSortInput = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumPriceDisplay = {
   INCLUDING_TAX: 'INCLUDING_TAX' as const,
   EXCLUDING_TAX: 'EXCLUDING_TAX' as const,
   BOTH: 'BOTH' as const
}

export const enumGender = {
   MALE: 'MALE' as const,
   FEMALE: 'FEMALE' as const
}

export const enumCustomerProjectStatus = {
   ACTIVE: 'ACTIVE' as const,
   ARCHIVED: 'ARCHIVED' as const,
   DELETED: 'DELETED' as const
}

export const enumBusinessStatus = {
   ACCEPTED: 'ACCEPTED' as const,
   DECLINED: 'DECLINED' as const,
   PENDING: 'PENDING' as const
}

export const enumMergeMethod = {
   COMBINE: 'COMBINE' as const,
   KEEP_NEW: 'KEEP_NEW' as const
}
